if (window.addEventListener && typeof mmLoaded == "undefined") {
    var newMenu = false;
    var schemaJSON = [
            { position: 0, icon: "", name: "Forside", link: "frontpage", type: "none" },
            {
                position: 1,
                icon: "none",
                name: "Kaffe",
                link: "collection",
                id: "357661579",
                type: "tree",
                items: [
                    { position: 0, name: "Alt kaffe", link: "collection", id: "357661579" },
                    { position: 1, name: "Mellemristet kaffe", link: "collection", id: "159689605197" },
                    { position: 2, name: "Espresso/m\u00f8rkristet", link: "collection", id: "362262923" },
                    { position: 3, name: "Hele kaffeb\u00f8nner", link: "collection", id: "158105501773" },
                    { position: 4, name: "Formalet filter", link: "collection", id: "158104584269" },
                    { position: 5, name: "Formalet til stempel", link: "collection", id: "338130443" },
                    { position: 6, name: "Kaffe p\u00e5 tilbud", link: "collection", id: "59816181837" },
                    { position: 7, name: "B\u00e6redygtigt kaffe", link: "collection", id: "150316875853" },
                    {
                        position: 8,
                        name: "Vores kaffelande",
                        link: "collection",
                        items: [
                            { position: 0, name: "Kaffe fra Brasilien", link: "collection", id: "59868119117" },
                            { position: 1, name: "Kaffe fra Colombia", link: "collection", id: "59868151885" },
                            { position: 2, name: "Kaffe fra Guatemala", link: "collection", id: "59868217421" },
                            { position: 3, name: "Kaffe fra Peru", link: "collection", id: "166453149773" },
                            { position: 4, name: "Kaffe fra Indien", link: "collection", id: "59868381261" },
                            { position: 5, name: "Kaffe fra Indonesien", link: "collection", id: "59868250189" },
                            { position: 6, name: "Kaffe fra Uganda", link: "collection", id: "81950081101" },
                        ],
                    },
                ],
            },
            { position: 2, icon: "", name: "Mellemristet", link: "collection", id: "159689605197", type: "none" },
            { position: 3, icon: "", name: "M\u00f8rkristet", link: "collection", id: "362262923", type: "none" },
            {
                position: 4,
                icon: "",
                name: "Formalet",
                link: "collection",
                id: "158104584269",
                type: "tree",
                items: [
                    { position: 0, name: "Til filterkaffe", link: "collection", id: "158104584269" },
                    { position: 1, name: "Til stempelkaffe", link: "collection", id: "158104617037" },
                ],
            },
            { position: 5, icon: "", name: "Kaffeudstyr", link: "collection", id: "362821771", type: "tree" },
            { position: 6, icon: "", name: "Erhverv", link: "page", id: "219289611", type: "none" },
            {
                position: 7,
                icon: "",
                name: "Om os",
                link: "page",
                id: "219400075",
                type: "tree",
                items: [
                    {
                        position: 0,
                        name: "Om Dinluksus",
                        link: "page",
                        id: "18629525581",
                        items: [
                            { position: 0, name: "S\u00e5dan handler du ", link: "page", id: "18629656653" },
                            { position: 1, name: "Hvem er Dinluksus?", link: "page", id: "18629525581" },
                        ],
                    },
                    { position: 1, name: "F\u00f8devarestyrelsen", link: "http", http: "https://www.findsmiley.dk/Sider/KontrolRapport.aspx?Virk1549848" },
                    { position: 2, name: "Em\u00e6rket", link: "page", id: "18598264909" },
                    { position: 3, name: "Trustpilot", link: "http", http: "https://dk.trustpilot.com/review/danluksus.com" },
                    { position: 4, name: "Facebook", link: "http", http: "https://www.facebook.com/dinluksus/" },
                    { position: 5, name: "Youtube", link: "http", http: "https://www.youtube.com/channel/UCvDitysK37N6rst3_j95kew" },
                    { position: 6, name: "Linkedin", link: "http", http: "https://www.linkedin.com/company-beta/17925327/" },
                    {
                        position: 7,
                        name: "Blog",
                        link: "no-link",
                        items: [
                            {
                                position: 0,
                                name: "G\u00e6steblogs",
                                link: "blog",
                                id: "21960032333",
                                items: [
                                    { position: 0, name: "Dinluksus deltager p\u00e5 mandesite 09.02.18", link: "article", id: "10819174477" },
                                    { position: 1, name: "Mandesager har skrevet om Dinluksus og vores kaffe", link: "article", id: "10920263757" },
                                ],
                            },
                        ],
                    },
                    {
                        position: 8,
                        name: "Kaffeguides",
                        link: "article",
                        id: "10736042061",
                        items: [
                            { position: 0, name: "Hvordan bruger jeg min m\u00e6lkeskummer?", link: "article", id: "10736042061" },
                            { position: 1, name: "Hvordan laver jeg stempelkaffe?", link: "collection", id: "57274957901" },
                        ],
                    },
                    {
                        position: 9,
                        name: "Sociale medier",
                        link: "frontpage",
                        items: [
                            { position: 0, name: "Bes\u00f8g vores Facebook", link: "http", http: "http://facebook.dk/dinluksus" },
                            { position: 1, name: "Dinluksus med i fodboldministeriet", link: "article", id: "28119269453" },
                        ],
                    },
                    {
                        position: 10,
                        name: "Nyhedsbreve",
                        link: "frontpage",
                        items: [
                            { position: 0, name: "\u00c5bning af fysisk shop! 27/04-18", link: "article", id: "10813538381" },
                            { position: 1, name: "Dinluksus deltager p\u00e5 mandesite 09.02.18", link: "article", id: "10819174477" },
                            { position: 2, name: "GDPR Nyhedsbrev 22.05.18", link: "article", id: "10930257997" },
                        ],
                    },
                ],
            },
        ],
        schemaLinksJSON = {
            frontpage: "/",
            collection: {
                "357661579": "/collections/kaffe",
                "159689605197": "/collections/mellemristet-kaffe",
                "362262923": "/collections/espressobonner",
                "158105501773": "/collections/hele-kaffebonner",
                "158104584269": "/collections/formalet-filterkaffe",
                "338130443": "/collections/stempelkaffe",
                "59816181837": "/collections/kaffe-pa-tilbud",
                "150316875853": "/collections/rainforest-alliance-certificeret-kaffe",
                "59868119117": "/collections/kaffe-fra-brasilien",
                "59868151885": "/collections/kaffe-fra-columbia",
                "59868217421": "/collections/kaffe-fra-guatemala",
                "59868381261": "/collections/kaffe-fra-indien",
                "59868250189": "/collections/kaffe-fra-indonesien",
                "81950081101": "/collections/kaffe-fra-uganda",
                "158104617037": "/collections/formalet-stempelkaffe",
                "362821771": "/collections/bryggeudstyr",
                "57274957901": "/collections/stempelkander-1",
            },
            page: { "219289611": "/pages/erhverv", "18629525581": "/pages/dinluksus", "18629656653": "/pages/sadan-handler-du-pa-siden", "18598264909": "/pages/dinluksus-er-emaerket-for-din-skyld" },
            blog: { "21960032333": "/blogs/gaesteblogs" },
            article: {
                "10819174477": "/blogs/nyhedsbreve/dinluksus-deltager-pa-mandesite-09-02-18",
                "10920263757": "/blogs/gaesteblogs/mandesitet-mandesager-har-skrevet-om-dinluksus-og-vores-kaffe",
                "10736042061": "/blogs/produkt-guides/hvordan-bruger-jeg-min-maelkeskummer",
                "28119269453": "/blogs/news/kaffesmagning-hos-fodboldministeriet",
                "10813538381": "/blogs/informationer-om-dinluksus/dinluksus-dk-abner-fysisk-shop",
                "10930257997": "/blogs/nyhedsbreve/gdpr-nyhedsbrev-22052018",
            },
        },
        schemaDesignJSON = [
            { action: "menu-select", value: "menu" },
            { action: "design", setting: "vertical_font_size", value: "13px" },
            { action: "design", setting: "vertical_link_hover_color", value: "#0da19a" },
            { action: "design", setting: "vertical_link_color", value: "#4e4e4e" },
            { action: "design", setting: "vertical_text_color", value: "#4e4e4e" },
            { action: "design", setting: "text_color", value: "#222222" },
            { action: "design", setting: "font_size", value: "13px" },
            { action: "design", setting: "button_text_color", value: "#ffffff" },
            { action: "design", setting: "button_text_hover_color", value: "#ffffff" },
            { action: "design", setting: "background_color", value: "#ffffff" },
            { action: "design", setting: "background_hover_color", value: "#f9f9f9" },
            { action: "design", setting: "link_color", value: "#4e4e4e" },
            { action: "design", setting: "button_background_color", value: "#0da19a" },
            { action: "design", setting: "link_hover_color", value: "#0da19a" },
            { action: "design", setting: "button_background_hover_color", value: "#0d8781" },
            { action: "design", setting: "tree_sub_direction", value: "set_tree_auto" },
            { action: "design", setting: "font_family", value: "Default" },
        ],
        mmLoaded = true,
        undo = [],
        redo = [],
        action = "",
        tempMenuObject = {},
        changedMenu = false,
        submenuToggled = false,
        changingPage = false,
        saving = false,
        panelOpened = false,
        verticalMenuMaxWidth = 10000,
        selectedMenu,
        clicked,
        touched,
        burgerIcon,
        disableOnClick = false,
        globalTouch = true,
        onClickOnlyReinit = false,
        disableOnScroll = false,
        mobileMenuMilliseconds = 350,
        ulPaths = [],
        customHeaderOffset = false,
        fontSize = 0,
        storeUlCount = 0,
        storeNavCount = 0,
        loadMegaMenuTries = 100,
        customMenuUls,
        setTreeDirection,
        defaultFontSelected = false,
        forceMobile = false,
        activateMegaMenu = true,
        previewPanelLoaded = false,
        allowMainMenuRecalibration = true,
        readyStateCheckInterval,
        addTouchNew = false,
        disableThemeScript = false,
        lazyLoadSupport = false,
        mmApplyOnce = false,
        initializedSchema = false;
    /* INITIALIZE MENU FUNCTIONS */ 
    function loadTRTMegaMenu() {
        /* in case the first load didn't work, because the wireframe didn't fully load in the dom, try again after 50 milliseconds */ 
        readyStateCheckInterval = setInterval(function () {
            if (jQueryTRT.isReady && !newMenu) {
                initTRTMegaMenu();
            }
        }, 100);
        setTimeout(function () {
            clearInterval(readyStateCheckInterval);
        }, 25000);
        /* in preview initSchema earlier, to show toolbar quicker even if page is loaded partialy (wireframe not loaded) */ if (window.self !== window.top) {
            /* try to load it in the window load event */ jQueryTRT(window).on("load", initSchema);
            /* timeout in case window load doesn't occur */ setTimeout(function () {
                initSchema();
            }, 5000);
        }
        /* load trt mega menu for the first time */ initTRTMegaMenu();
        
    }
    function initTRTMegaMenu() {
        /* check if wireframe exists and is fully loaded */ if (jQueryTRT(".trt-hidden-wireframe").length > 0 && jQueryTRT(".trt-hidden-wireframe").next().length > 0) {
            newMenu = jQueryTRT(".trt-hidden-wireframe").first().html();
            clearInterval(readyStateCheckInterval);
        } else {
            return false;
        }
        /* check it mega menu app is installed */ var installed = true;
        jQueryTRT("script").each(function () {
            if (jQueryTRT(this).text().indexOf("mm-init.js?") != -1 && jQueryTRT(this).text().indexOf("asyncLoad") != -1 && jQueryTRT(this).text().indexOf("initSchema") == -1) {
                installed = true;
            }
        });
        /* jQueryTRT("html").html().indexOf("assets\/mm-init.js?")!=-1 */ if (installed) {
            var iterations = 0;
            /* bundle app by smar7 apps fix */ var bundleAppMutations = setInterval(function () {
                iterations++;
                if (typeof mutationExceptions !== "undefined") {
                    mutationExceptions[mutationExceptions.length] = ".trt-menu-item";
                    clearInterval(bundleAppMutations);
                }
                if (iterations > 10) {
                    clearInterval(bundleAppMutations);
                }
            }, 1000);
            if (disableThemeScript == false) {
                jQueryTRT(window).on("load", function () {
                    if (typeof timber != "undefined") {
                        timber.responsiveNav = function () {};
                        timber.alignMenu = function () {};
                    }
                    setTimeout(function () {
                        if (typeof timber != "undefined") {
                            timber.responsiveNav = function () {};
                            timber.alignMenu = function () {};
                        }
                    }, 400);
                });
                $(window).resize(function () {
                    if (typeof timber != "undefined") {
                        timber.responsiveNav = function () {};
                        timber.alignMenu = function () {};
                    }
                });
            }
            initSchema();
            /* remove shopify fixed top bar (keep verifying in case you navigate with mobile view, then resize) */ if (window.self !== window.top) {
                jQueryTRT("#admin_bar_iframe").remove();
                jQueryTRT("html").css("padding-top", "0px");
                setInterval(function () {
                    jQueryTRT("*").each(function () {
                        if (jQueryTRT(this).css("top") == "40px" && jQueryTRT(this).css("position") == "fixed") {
                            jQueryTRT(this).css("top", "0");
                        }
                    });
                }, 1000);
            }
            var reinitTimeout;
            var windowWidth = jQueryTRT(window).width();
            jQueryTRT(window).resize(function () {
                if (windowWidth != jQueryTRT(window).width()) {
                    jQueryTRT(".mm-hovering").removeClass("mm-hovering");
                    jQueryTRT(".submenu-opened").hide().removeClass("submenu-opened");
                    jQueryTRT(".fa-minus-circle").removeClass("fa-minus-circle").addClass("fa-plus-circle");
                    clearTimeout(reinitTimeout);
                    reinitTimeout = setTimeout(function () {
                        jQueryTRT(document).trigger("mmWindowResize");
                        applyMegaMenu();
                        applyOnClick();
                        windowWidth = jQueryTRT(window).width();
                    }, 300);
                }
            });
            if (!disableOnScroll) {
                /* DEPRECATED var reinitScrollTimeout; jQueryTRT(window).scroll(function(){ clearTimeout(reinitScrollTimeout); reinitScrollTimeout = setTimeout(function(){ var submenuVisible = false; jQueryTRT(".horizontal-mega-menu>.trt-menu-item>.mm-submenu").each(function(){ if (parseInt(jQueryTRT(this).css("top"))>0) { setSubmenuBoundries(jQueryTRT(this).parent()); } }); },10); }); */ /* if static main menu, add overflow */ var reinitScrollTimeout;
                setInterval(function () {
                    jQueryTRT(".horizontal-mega-menu>.trt-menu-item>.mm-submenu").each(function () {
                        if (parseInt(jQueryTRT(this).css("top")) > 0) {
                            var li = jQueryTRT(this).parent();
                            if (li.find(">ul.mm-submenu.simple").length > 0 || li.find(">ul.mm-submenu.tabbed").length > 0) {
                                var hasPositionStatic = false;
                                li.parent()
                                    .parents()
                                    .each(function () {
                                        if (jQueryTRT(this).css("position") == "fixed") {
                                            hasPositionStatic = true;
                                        }
                                    });
                                if (li.find(">ul.mm-submenu.simple").length > 0) {
                                    var submenu = li.find(">ul.mm-submenu.simple");
                                } else {
                                    var submenu = li.find(">ul.mm-submenu.tabbed");
                                }
                                if (hasPositionStatic) {
                                    var headerHeight = parseInt(submenu.offset().top - jQueryTRT(window).scrollTop());
                                    var maxHeight = jQueryTRT(window).height() - headerHeight;
                                    if (jQueryTRT(window).height() - 50 < submenu.height()) {
                                        submenu.css({ "max-height": maxHeight + "px", overflow: "scroll", "overflow-x": "hidden" });
                                    } /* in case there is little content on a page and the main menu is fixed */
                                } else if (jQueryTRT(document).height() - 200 <= jQueryTRT(window).height()) {
                                    var maxHeight = jQueryTRT(document).height() - 250;
                                    submenu.css({ "max-height": maxHeight + "px", overflow: "scroll", "overflow-x": "hidden" });
                                } else {
                                    submenu.css({ "max-height": "none", overflow: "hidden" });
                                }
                            }
                        }
                    });
                }, 1000);
            }
            /* skip our own ul's in the dom change poller to avoid unwanted multiple menu applications. also skip specific theme uls and uls that have no a[href] (if customMenuUls is used let dom change poller watch for uls without a as well) */ var possibleMenuUls =
                "ul:not(.trt-menu-item ul, .trt-hidden-wireframe ,.flex-direction-nav)";
            if (typeof customMenuUls === "undefined") possibleMenuUls += ":has(a[href])";
            var loadMegaMenuCount = 1;
            if (storeUlCount != jQueryTRT(possibleMenuUls).length || storeNavCount != jQueryTRT("nav").length) {
                storeUlCount = jQueryTRT(possibleMenuUls).length;
                storeNavCount = jQueryTRT("nav").length;
                applyMegaMenu();
                /* when a certain element is clicked, reinit the menus and reset the simple submenu width, in case the side menu is hidden */ applyOnClick();
            }
            clearInterval(loadMegaMenu);
            var loadMegaMenu = setInterval(function () {
                loadMegaMenuCount++;
                if (loadMegaMenuCount > loadMegaMenuTries) {
                    clearInterval(loadMegaMenu);
                }
                if (storeUlCount != jQueryTRT(possibleMenuUls).length || storeNavCount != jQueryTRT("nav").length) {
                    storeUlCount = jQueryTRT(possibleMenuUls).length;
                    storeNavCount = jQueryTRT("nav").length;
                    /* if customMenuUls also avoid reappling the menu if it is already applied -> performance fix */ if (typeof customMenuUls !== "undefined") {
                        var numAlreadyApplied = 0;
                        var menus = customMenuUls.split(",");
                        jQueryTRT.each(menus, function (key, value) {
                            /*element exist in page and is already applied -> return*/ if (jQueryTRT(value).length > 0 && jQueryTRT(value).is(".vertical-mega-menu,.horizontal-mega-menu")) numAlreadyApplied++;
                        });
                        /* all requested custom menus are already applied => do nothing */ if (numAlreadyApplied == menus.length) {
                            clearInterval(loadMegaMenu);
                            return;
                        }
                    }
                    applyMegaMenu();
                    /* when a certain element is clicked, reinit the menus and reset the simple submenu width, in case the side menu is hidden */ applyOnClick();
                }
            }, 100);
        } else if (typeof hideOriginalMenuInterval !== "undefined") {
            jQueryTRT(".trt-disabled-menu").removeClass("trt-disabled-menu");
            jQueryTRT("link[href]").each(function () {
                if (jQueryTRT(this).attr("href").indexOf("trt-megamenu.css") !== -1) {
                    jQueryTRT(this).remove();
                }
            });
            clearInterval(hideOriginalMenuInterval);
        } else {
            jQueryTRT(".trt-disabled-menu").removeClass("trt-disabled-menu");
            jQueryTRT("link[href]").each(function () {
                if (jQueryTRT(this).attr("href").indexOf("trt-megamenu.css") !== -1) {
                    jQueryTRT(this).remove();
                }
            });
        }
        jQueryTRT(window).on("beforeunload", function () {
            if (window.self !== window.top && (undo.length > 0 || changedMenu) && !saving) {
                return "You might have unsaved changes.";
            }
        }); /* jQueryTRT(window).on("unload", function() { changingPage = true; if (window.self!==window.top) { var preview = parent; if (typeof parent.postMessage === "undefined") { preview = top; } preview.postMessage("startLoader", "*" ); } }); */
    }
    /* when a certain element is clicked, reinit the menus and reset the simple submenu width, in case the side menu is hidden */ function applyOnClick() {
        if (!disableOnClick && selectedMenu != undefined && selectedMenu != "none") {
            clicked = false;
            if (jQueryTRT(burgerIcon).length == 0) {
                burgerIcon = false;
            }
            jQueryTRT(burgerIcon || "*").unbind("click.apply-mm");
            jQueryTRT(burgerIcon || "*").bind("click.apply-mm", function () {
                var element = jQueryTRT(this);
                if (!clicked && !touched) {
                    clicked = true;
                    setTimeout(function () {
                        /* visibility is checked for the brooklin alike themes: applyMM also on items placed under the mm ul and not under the mainMenuItems, if the mainMenuItems are hidden (exclude search in mobile view but not burger button). */ if (
                            !changingPage &&
                            element.closest(".trt-menu-item").length == 0 &&
                            (element.closest(".horizontal-mega-menu").length == 0 || (element.closest(".horizontal-mega-menu").length != 0 && !$(element.closest(".horizontal-mega-menu").find(".trt-menu-item")).is(":visible"))) &&
                            (element.closest(".vertical-mega-menu").length == 0 || (element.closest(".vertical-mega-menu").length != 0 && !$(element.closest(".vertical-mega-menu").find(".trt-menu-item")).is(":visible"))) &&
                            !element.hasClass("stop-mega-menu-reinit")
                        ) {
                            if (onClickOnlyReinit) {
                                jQueryTRT.each(ulPaths, function (index, value) {
                                    reinitMenus(value);
                                });
                            } else {
                                applyMegaMenu();
                            }
                            /* This fix makes it work with the BEST Currency Converter app */ if (typeof DoublyGlobalCurrency !== "undefined") {
                                if (jQueryTRT(".currency-switcher-btn.selected").length > 0) {
                                    DoublyGlobalCurrency.convertAll(jQueryTRT(".currency-switcher-btn.selected").attr("doubly-currency"));
                                } else if (jQueryTRT("[name=doubly-currencies]").length > 0) {
                                    DoublyGlobalCurrency.convertAll(jQueryTRT("[name=doubly-currencies]").val());
                                }
                            }
                        }
                    }, mobileMenuMilliseconds);
                }
                setTimeout(function () {
                    clicked = false;
                }, mobileMenuMilliseconds + 50);
            });
        }
    }
    function initSchema() {
        if (initializedSchema == false) {
            initializedSchema = true;
            if (typeof schemaJSON == "string") {
                schemaJSON = JSON.parse(schemaJSON);
            }
            if (typeof schemaLinksJSON == "string") {
                schemaLinksJSON = JSON.parse(schemaLinksJSON);
            }
            if (typeof schemaDesignJSON == "string") {
                schemaDesignJSON = JSON.parse(schemaDesignJSON);
            }
            /* apply custom design */ recreateDesign();
            action = "";
            if (window.self !== window.top) {
                var preview = parent;
                if (typeof parent.postMessage === "undefined") {
                    preview = top;
                }
                preview.postMessage(["updateToolbar", JSON.stringify(schemaDesignJSON), JSON.stringify(linkLists), JSON.stringify(undo), JSON.stringify(redo), changedMenu], "*");
            }
        }
    }
    function iframeReady() {
        previewPanelLoaded = true;
        document
            .getElementById("mega-menu-iframe")
            .contentWindow.postMessage(["updateToolbar", JSON.stringify(schemaDesignJSON), JSON.stringify(linkLists), JSON.stringify(undo), JSON.stringify(redo), changedMenu], "https://trtapps.com");
    }
    function reloadPreview() {
        location.reload();
    }
    /* add countdown to target mainMenuItem */ function initCountdown(mainMenuItem) {
        var date = mainMenuItem.attr("countdown");
        /* init countdown with the configured date attr */ if (mainMenuItem.find(".trt-menu-item-countdown").length == 0 && date != undefined && !isNaN(Date.parse(date))) {
            /* date attr is valid */ /* time to elapse is (date - NOW) % 24h */ var timeUntilElapseInSeconds = ((new Date(date).getTime() - new Date().getTime()) / 1000) % 86400;
            if (timeUntilElapseInSeconds < 0) timeUntilElapseInSeconds += 86400;
            /* add countdown tag and init flipClock */ if (mainMenuItem.find(">a>i.fa-angle-down:last").length > 0) {
                mainMenuItem.find(">a>i.fa-angle-down:last").before(' <i class="trt-menu-item-countdown"> <div></div> </i>');
            } else {
                mainMenuItem.find(">a").append(' <i class="trt-menu-item-countdown"> <div></div> </i>');
            }
            mainMenuItem.find(".trt-menu-item-countdown>div").FlipClock(timeUntilElapseInSeconds, { clockFace: "DailyCounter", countdown: true });
        }
    }
    function shadeColor(color, percent) {
        var f = parseInt(color.slice(1), 16),
            t = percent < 0 ? 0 : 255,
            p = percent < 0 ? percent * -1 : percent,
            R = f >> 16,
            G = (f >> 8) & 0x00ff,
            B = f & 0x0000ff;
        return "#" + (0x1000000 + (Math.round((t - R) * p) + R) * 0x10000 + (Math.round((t - G) * p) + G) * 0x100 + (Math.round((t - B) * p) + B)).toString(16).slice(1);
    }
    /* add further css styles for a certain propSetting */ function customPropSettingsStyles(setting, value) {
        var style = "";
        switch (setting) {
            case "countdown_background_color":
                value = shadeColor(value, -0.5);
                /* style countdown shadow too */ style +=
                    ".flip-clock-wrapper ul.play li.flip-clock-before .up .shadow {" +
                    "background: -moz-linear-gradient(top, rgba(0, 0, 0, 0.1) 0%, " +
                    value +
                    " 100%) !important;" +
                    "background: -webkit-gradient(linear, left top, left bottom, color-stop(0%, rgba(0, 0, 0, 0.1)), color-stop(100%, " +
                    value +
                    ")) !important;" +
                    "background: linear, top, rgba(0, 0, 0, 0.1) 0%, " +
                    value +
                    " 100% !important;" +
                    "background: -o-linear-gradient(top, rgba(0, 0, 0, 0.1) 0%, " +
                    value +
                    " 100%) !important;" +
                    "background: -ms-linear-gradient(top, rgba(0, 0, 0, 0.1) 0%, " +
                    value +
                    " 100%) !important;" +
                    "background: linear, to bottom, rgba(0, 0, 0, 0.1) 0%, " +
                    value +
                    " 100% !important;}";
                style +=
                    ".flip-clock-wrapper ul.play li.flip-clock-active .up .shadow {" +
                    "background: -moz-linear-gradient(top, rgba(0, 0, 0, 0.1) 0%," +
                    value +
                    " 100%) !important;" +
                    "background: -webkit-gradient(linear, left top, left bottom, color-stop(0%, rgba(0, 0, 0, 0.1)), color-stop(100%, " +
                    value +
                    ")) !important;" +
                    "background: linear, top, rgba(0, 0, 0, 0.1) 0%, " +
                    value +
                    " 100% !important;" +
                    "background: -o-linear-gradient(top, rgba(0, 0, 0, 0.1) 0%, " +
                    value +
                    " 100%) !important;" +
                    "background: -ms-linear-gradient(top, rgba(0, 0, 0, 0.1) 0%, " +
                    value +
                    " 100%) !important;" +
                    "background: linear, to bottom, rgba(0, 0, 0, 0.1) 0%, " +
                    value +
                    " 100% !important;}";
                style +=
                    ".flip-clock-wrapper ul.play li.flip-clock-before .down .shadow {" +
                    "background: -moz-linear-gradient(top, " +
                    value +
                    " 0%, rgba(0, 0, 0, 0.1) 100%) !important;" +
                    "background: -webkit-gradient(linear, left top, left bottom, color-stop(0%, " +
                    value +
                    "), color-stop(100%, rgba(0, 0, 0, 0.1))) !important;" +
                    "background: linear, top, " +
                    value +
                    " 0%, rgba(0, 0, 0, 0.1) 100% !important;" +
                    "background: -o-linear-gradient(top, " +
                    value +
                    " 0%, rgba(0, 0, 0, 0.1) 100%) !important;" +
                    "background: -ms-linear-gradient(top, " +
                    value +
                    " 0%, rgba(0, 0, 0, 0.1) 100%) !important;" +
                    "background: linear, to bottom, " +
                    value +
                    " 0%, rgba(0, 0, 0, 0.1) 100% !important;}";
                style +=
                    ".flip-clock-wrapper ul.play li.flip-clock-active .down .shadow {" +
                    "background: -moz-linear-gradient(top, " +
                    value +
                    " 0%, rgba(0, 0, 0, 0.1) 100%) !important;" +
                    "background: -webkit-gradient(linear, left top, left bottom, color-stop(0%, " +
                    value +
                    "), color-stop(100%, rgba(0, 0, 0, 0.1))) !important;" +
                    "background: linear, top, " +
                    value +
                    " 0%, rgba(0, 0, 0, 0.1) 100% !important;" +
                    "background: -o-linear-gradient(top, " +
                    value +
                    " 0%, rgba(0, 0, 0, 0.1) 100%) !important;" +
                    "background: -ms-linear-gradient(top, " +
                    value +
                    " 0%, rgba(0, 0, 0, 0.1) 100%) !important;" +
                    "background: linear, to bottom, " +
                    value +
                    " 0%, rgba(0, 0, 0, 0.1) 100% !important;}";
                break;
        }
        return style;
    }
    function applyMegaMenu(menu) {
        /* bundle app by smar7 apps fix */ if (typeof mutationExceptions !== "undefined") {
            mutationExceptions[mutationExceptions.length] = "ul";
        }
        if (typeof hideOriginalMenuInterval !== "undefined") {
            clearInterval(hideOriginalMenuInterval);
        }
        if (menu != undefined) {
            var newSchemaDesign = [];
            selectedMenu = menu;
            jQueryTRT.each(schemaDesignJSON, function (key, item) {
                if (item.action != "menu-select") {
                    newSchemaDesign.push(item);
                }
            });
            schemaDesignJSON = newSchemaDesign;
            changedMenu = true;
        } else {
            jQueryTRT.each(schemaDesignJSON, function (key, item) {
                if (item.action == "menu-select") {
                    selectedMenu = item.value;
                }
            });
        }
        if (mmApplyOnce == false) {
            jQueryTRT(".vertical-mega-menu").removeClass("vertical-mega-menu");
            jQueryTRT(".horizontal-mega-menu").removeClass("horizontal-mega-menu");
            jQueryTRT(".trt-disabled").removeClass("trt-disabled");
            jQueryTRT(".trt-menu-item").remove();
            jQueryTRT("#themeScript").remove();
        }
        var links = [];
        jQueryTRT.each(linkLists, function (key, item) {
            if (selectedMenu == key) {
                links = item.items;
                return false;
            }
        });
        if (window.self !== window.top) {
            console.log(links);
        }
        if (activateMegaMenu == false) {
            selectedMenu = "none";
        }
        if (selectedMenu != undefined && selectedMenu != "none" && (links.length > 0 || customMenuUls != undefined)) {
            jQueryTRT(customMenuUls || "ul,nav").each(function () {
                var forceMenu = false;
                var elementFits = 0;
                var skipCheck = false;
                tempMenuObject = {};
                tempMenuObject.ul = jQueryTRT(this);
                /* Skip reapplying with mmApplyOnce. ThemeScript is 99% in after or beforeinit -> no need to remove */ if (mmApplyOnce == true) {
                    if (tempMenuObject.ul.is(".vertical-mega-menu, .horizontal-mega-menu")) {
                        return true;
                    }
                }
                if (disableThemeScript == false) {
                    if (typeof timber != "undefined") {
                        timber.alignMenu = function () {};
                    } /*if (jQueryTRT("#moreMenu--list").length>0) { jQueryTRT("#moreMenu--list>li").each(function(){ jQueryTRT(this).appendTo(jQueryTRT(this).closest("#accessibleNav")); }); jQueryTRT("#moreMenu").remove(); } setTimeout(function(){ if (jQueryTRT("#moreMenu--list").length>0) { jQueryTRT("#moreMenu--list>li").each(function(){ jQueryTRT(this).appendTo(jQueryTRT(this).closest("#accessibleNav")); }); jQueryTRT("#moreMenu").remove(); applyMegaMenu(); } },1000); jQueryTRT(window).resize(function () { if (jQueryTRT("#moreMenu--list").length>0) { jQueryTRT("#moreMenu--list>li").each(function(){ jQueryTRT(this).appendTo(jQueryTRT(this).closest("#accessibleNav")); }); jQueryTRT("#moreMenu").remove(); } });*/
                }
                if (!skipCheck) {
                    jQueryTRT(this)
                        .children("li")
                        .each(function () {
                            var li = jQueryTRT(this);
                            var a = li.find("a").first();
                            var href = a.attr("href");
                            if ((href == undefined || (href != undefined && (href.substr(0, 1) == "#" || href == ""))) && li.find("a:nth-child(2)").length > 0) {
                                a = li.find("a:nth-child(2)");
                                href = a.attr("href");
                            } else if ((href == undefined || (href != undefined && (href.substr(0, 1) == "#" || href == ""))) && li.find("a>a").length > 0) {
                                a = li.find("a>a");
                                href = a.attr("href");
                            }
                            /*if (typeof href !== "undefined") { href = href.replace("http://"+trtMegaMenuShop,"").replace("https://"+trtMegaMenuShop,""); }*/ if (links[elementFits] != undefined && href == links[elementFits]) {
                                if (tempMenuObject.liClasses == undefined) {
                                    tempMenuObject.liClasses = "";
                                }
                                tempMenuObject.liClasses = concatClasses(li.attr("class"), tempMenuObject.liClasses);
                                if (tempMenuObject.aClasses == undefined) {
                                    tempMenuObject.aClasses = [];
                                }
                                tempMenuObject.aClasses = concatClasses(a.attr("class"), tempMenuObject.aClasses);
                                if (tempMenuObject.liItems == undefined) {
                                    tempMenuObject.liItems = [];
                                }
                                if (jQueryTRT.inArray(li, tempMenuObject.liItems) == -1) {
                                    tempMenuObject.liItems[tempMenuObject.liItems.length] = li;
                                }
                                li.addClass("trt-transparent");
                                elementFits++;
                            } else if (elementFits > 0 && elementFits != links.length) {
                                elementFits = 0;
                                tempMenuObject.liItems = [];
                                jQueryTRT(".trt-transparent").removeClass("trt-transparent");
                                if (href == links[0]) {
                                    elementFits = 1;
                                    tempMenuObject.liItems[tempMenuObject.liItems.length] = li;
                                    li.addClass("trt-transparent");
                                }
                            }
                        });
                }
                if ((elementFits > 0 && elementFits == links.length) || forceMenu) {
                    var liClasses = getSpecificClasses(tempMenuObject.liClasses);
                    var aClasses = getSpecificClasses(tempMenuObject.aClasses);
                    jQueryTRT.each(tempMenuObject.liItems, function (key, item) {
                        jQueryTRT(item).removeClass("trt-transparent").addClass("trt-disabled");
                    });
                    if (newMenu) {
                        jQueryTRT(this).prepend(newMenu);
                        jQueryTRT(this).find(".trt-menu-item").addClass(liClasses["common"]);
                        jQueryTRT(this).find(".trt-menu-item").find(">a").attr("class", aClasses["common"]);
                        /* Add countdown */ jQueryTRT(this)
                            .find(".trt-menu-item[countdown]")
                            .each(function () {
                                initCountdown(jQueryTRT(this));
                            });
                        /* Init data-src instead of src in case lazyload support is enabled */ var imgAttr = "src";
                        if (lazyLoadSupport == true) {
                            imgAttr = "data-src";
                        }
                        /* Add Colection Images */ jQueryTRT(this)
                            .find(".get-collection-image")
                            .each(function () {
                                var element = jQueryTRT(this);
                                var dataId = element.data("id");
                                if (collectionImages[dataId] != undefined && collectionImages[dataId].indexOf("no-image") == -1) {
                                    element.attr(imgAttr, collectionImages[dataId]);
                                }
                            });
                        /* Add Product Images */ jQueryTRT(this)
                            .find(".get-product-image")
                            .each(function () {
                                var element = jQueryTRT(this);
                                var dataId = element.data("id");
                                if (productImages[dataId] != undefined && productImages[dataId].indexOf("no-image") == -1) {
                                    element.attr(imgAttr, productImages[dataId]);
                                }
                            });
                        if (lazyLoadSupport == true) {
                            /* add fade transitions for lazysizes */ if (jQueryTRT('style[id="trtMmLazySizes"]').length == 0)
                                jQueryTRT("head").append(
                                    '<style id="trtMmLazySizes"> .trt-menu-item .lazyloaded { opacity: 1 !important; -webkit-transition: opacity .35s ease; transition: opacity .35s ease; } .trt-menu-item .lazyload,.trt-menu-item .lazyloading {opacity: 0 !important; } </style>'
                                );
                            jQueryTRT(this).find("img[data-src]").addClass("lazyload");
                        }
                        /* Add Product Prices */ jQueryTRT(this)
                            .find(".get-mega-menu-prices")
                            .each(function () {
                                var element = jQueryTRT(this);
                                var dataId = element.data("id");
                                if (prices[dataId] != undefined) {
                                    element.html(prices[dataId]);
                                } else {
                                    /* hide br to keep vertical alignment */ element.parent().find("br").attr("style", "display: none;");
                                }
                            });
                    }
                    if (newMenu === false || newMenu == "" || newMenu == "undefined" || newMenu === null) {
                        jQueryTRT.each(schemaJSON.reverse(), function (key, item) {
                            var firstLi = tempMenuObject.ul.find(">li").first();
                            if (firstLi.find("a").length == 0 && firstLi.next().find("a").length > 0) {
                                var clone = firstLi.next().clone();
                            } else {
                                var clone = firstLi.clone();
                            }
                            var insertedClone = clone
                                .prependTo(tempMenuObject.ul)
                                .removeAttr("class")
                                .addClass("trt-menu-item " + liClasses["common"]);
                            var customA = false;
                            if (item.link == "no-link") {
                                var dataHref = "no-link";
                                var href = "javascript:void(0);";
                            } else if (item.link == "http") {
                                var dataHref = item.http;
                                var href = item.http;
                            } else {
                                var dataHref = item.id != undefined && schemaLinksJSON[item.link] != undefined && schemaLinksJSON[item.link][item.id] != undefined ? schemaLinksJSON[item.link][item.id] : schemaLinksJSON[item.link];
                                var href = item.id != undefined && schemaLinksJSON[item.link] != undefined && schemaLinksJSON[item.link][item.id] != undefined ? schemaLinksJSON[item.link][item.id] : schemaLinksJSON[item.link];
                            }
                            var icon = "";
                            if (item.icon != undefined && item.icon != "" && item.icon != "none") {
                                icon = '<i class="fa fa-' + item.icon + '" aria-hidden="true"></i> ';
                            }
                            var aContent = icon + item.name.replace(/&quot;/g, '"');
                            if (
                                insertedClone.find("a").first().find(">:first-child").length > 0 &&
                                insertedClone.find("a").first().find(">:first-child").prop("tagName").toLowerCase() == "span" &&
                                insertedClone.find("a").first().find("span").first().text().trim() == insertedClone.find("a").first().text().trim()
                            ) {
                                var spanClass = insertedClone.find("a").first().find(">:first-child").attr("class");
                                if (spanClass != "undefined") {
                                    aContent = '<span class="' + spanClass + '">' + aContent + "</span>";
                                } else {
                                    aContent = "<span>" + aContent + "</span>";
                                }
                            }
                            var useOnClick = "";
                            if (window.self === window.top || (window.self !== window.top && window.name == "mega-menu-iframe")) {
                                useOnClick = 'onclick="return mmGoToPage(this)"';
                            }
                            if (customA) {
                                var aHtml = customA;
                            } else {
                                var aHtml =
                                    '<a class="' +
                                    aClasses["common"] +
                                    '" href="' +
                                    href +
                                    '" data-href="' +
                                    dataHref +
                                    '" ' +
                                    useOnClick +
                                    ' aria-label="' +
                                    jQueryTRT("<div/>")
                                        .html(item.name.replace(/&quot;/g, '"'))
                                        .text() +
                                    '" data-no-instant>' +
                                    aContent +
                                    "</a>";
                            }
                            var submenuHtml = addSubMenus(item);
                            insertedClone.html(aHtml + submenuHtml);
                            if (item.type == "contact") {
                                jQueryTRT("#mm-contact").clone().appendTo(insertedClone).show().removeAttr("id");
                            }
                        });
                        /* add arrow to main menu items that have submenus */ tempMenuObject.ul.find(">li").each(function () {
                            if (jQueryTRT(this).find("ul.mm-submenu").length > 0) {
                                if (jQueryTRT(this).find(">a>span").length > 0) {
                                    jQueryTRT(this).find(">a>span").append('&nbsp;<i class="fa fa-angle-down" aria-hidden="true"></i>');
                                } else {
                                    jQueryTRT(this).find(">a").append('&nbsp;<i class="fa fa-angle-down" aria-hidden="true"></i>');
                                }
                            }
                        });
                        /* add toggle submenu button for vertical menu */ tempMenuObject.ul.find(" ul.mm-submenu").each(function () {
                            if (jQueryTRT(this).parent().find(">a>span").length > 0) {
                                jQueryTRT(this).parent().find(">a>span").append(' <button class="toggle-menu-btn" style="display:none;" onclick="return toggleSubmenu(this)"><i class="fa fa-plus-circle" aria-hidden="true"></i></button>');
                            } else {
                                jQueryTRT(this).parent().find(">a").append(' <button class="toggle-menu-btn" style="display:none;" onclick="return toggleSubmenu(this)"><i class="fa fa-plus-circle" aria-hidden="true"></i></button>');
                            }
                        });
                    }
                    schemaJSON.reverse();
                    if (liClasses["first"] || aClasses["first"] || liClasses["last"] || aClasses["last"]) {
                        tempMenuObject.ul.find(".trt-menu-item").first().addClass(liClasses["first"]);
                        tempMenuObject.ul.find(".trt-menu-item").last().addClass(liClasses["last"]);
                        tempMenuObject.ul.find(".trt-menu-item").first().find("a").first().addClass(aClasses["first"]);
                        tempMenuObject.ul.find(".trt-menu-item").last().find("a").first().addClass(aClasses["last"]);
                    }
                    /* set menu item as active */ if (liClasses["active"] || aClasses["active"]) {
                        tempMenuObject.ul.find(">.trt-menu-item").each(function () {
                            var a = jQueryTRT(this).find("a").first();
                            if (a.attr("data-href") == window.location.pathname) {
                                a.addClass(aClasses["active"]);
                                jQueryTRT(this).addClass(liClasses["active"]);
                            }
                        });
                    }
                    tempMenuObject = {};
                    /* add theme specific scripts if mega menu added */ if (disableThemeScript == false) {
                        verticalMenuMaxWidth = 768;
                        /* user request 45984 */ if (jQueryTRT("style[id=themeScript]").length == 0)
                            jQueryTRT("head").append(
                                ' <style id="themeScript"> ul > li.trt-menu-item { z-index: 10000 !important; } ul > li.trt-menu-item:hover { z-index: 10001 !important; } ul > li.trt-menu-item.mega-hover { z-index: 10001 !important; } #MobileNav .trt-menu-item {display: block !important; } </style> '
                            );
                    }
                    /* stop the applyOnClick function from running when you click on search or text fields, so that the submenus won't close when you're on mobile and you click on the search field */ jQueryTRT(
                        'input[type="search"],input[type="text"]'
                    ).addClass("stop-mega-menu-reinit");
                    /* FIXES START */ /* fix for any dl-menu */ if (jQueryTRT(".dl-menu").length > 0) {
                        setTimeout(function () {
                            jQueryTRT(".toggle-menu-btn").click(function () {
                                setTimeout(function () {
                                    jQueryTRT(".dl-menu").addClass("dl-menuopen");
                                }, 1);
                            });
                        }, 100);
                    }
                    /* Supply Theme more menu fix (for when people have theme_store_id 0) */ if (typeof timber !== "undefined" && typeof timber.alignMenu !== "undefined") {
                        timber.alignMenu = function () {};
                    }
                    /* FIXES END */ var ulPath = getUlPath(jQueryTRT(this));
                    var isSubmenuOfPreviousUlPath = false;
                    if (jQueryTRT.inArray(ulPath, ulPaths) == -1 && !jQueryTRT(this).hasClass("trt-hidden-wireframe") && ulPath.indexOf(".trt-hidden-wireframe") == -1) {
                        jQueryTRT.each(ulPaths, function (index, value) {
                            if (ulPath.indexOf(value) !== -1) {
                                isSubmenuOfPreviousUlPath = true;
                            }
                        });
                        if (!isSubmenuOfPreviousUlPath) {
                            ulPaths[ulPaths.length] = ulPath;
                        }
                    }
                } else {
                    jQueryTRT(".trt-transparent").removeClass("trt-transparent");
                }
            });
            jQueryTRT(".trt-disabled-menu").removeClass("trt-disabled-menu");
            jQueryTRT.each(ulPaths, function (index, value) {
                reinitMenus(value);
            });
            if (addTouchNew == false) {
                addTouch();
            } else {
                addTouch2();
            }
        }
        if (window.self !== window.top) {
            var preview = parent;
            if (typeof parent.postMessage === "undefined") {
                preview = top;
            }
            preview.postMessage(["updateToolbar", JSON.stringify(schemaDesignJSON), JSON.stringify(linkLists), JSON.stringify(undo), JSON.stringify(redo), changedMenu], "*");
        } else if (previewPanelLoaded) {
            document
                .getElementById("mega-menu-iframe")
                .contentWindow.postMessage(["updateToolbar", JSON.stringify(schemaDesignJSON), JSON.stringify(linkLists), JSON.stringify(undo), JSON.stringify(redo), changedMenu], "https://trtapps.com");
        }
        /* bundle app by smar7 apps fix */ setTimeout(function () {
            if (typeof mutationExceptions !== "undefined") {
                mutationExceptions.pop();
            }
        }, 100);
    }
    /* determines if menu should be vertical or horizontal */ function reinitMenus(ulPath) {
        /* if(!jQueryTRT(ulPath).is(":visible") && (typeof jQueryTRT(ulPath).attr("style")===typeof undefined || jQueryTRT(ulPath).attr("style").replace(/ /g, "").indexOf("display:none")==-1 || (jQueryTRT(ulPath).attr("style").replace(/ /g, "").indexOf("display:none")!=-1 && jQueryTRT(ulPath).css("display")=="none"))) { return; } */ jQueryTRT(
            ".submenu-opened"
        ).hide();
        var previousItemTop;
        /* var horizontal = true; */ var verticalItemsNr = 1;
        jQueryTRT(ulPath + ">.trt-menu-item>a").each(function () {
            /* .offset() is relative to document */ var currentItemTop = jQueryTRT(this).offset().top;
            /* menuitems are positioned one below each other -> mobile rendering */ previousItemTop = previousItemTop == undefined ? currentItemTop : previousItemTop;
            if (currentItemTop > previousItemTop + 5 || currentItemTop < previousItemTop - 5) {
                verticalItemsNr++;
            }
            previousItemTop = currentItemTop;
        });
        /* var oldYPosition = 0; var oldXPosition = 0; var increment = 0; jQueryTRT(ulPath+">.trt-menu-item").each(function() { var positionY = jQueryTRT(this).position().top; var positionX = jQueryTRT(this).position().left; var differenceY = positionY - oldYPosition; var differenceX = positionX - oldXPosition; if(increment>0){ if(differenceY>3 || differenceX<3) { verticalItemsNr++; } } oldYPosition = positionY; oldXPosition = positionX; increment++; }); */ if (
            (verticalItemsNr != jQueryTRT(ulPath + ">.trt-menu-item").length || (verticalItemsNr == 1 && jQueryTRT("body").width() > verticalMenuMaxWidth)) &&
            forceMobile == false
        ) {
            /* if ( verticalItemsNr==1 && forceMobile==false ) { */ jQueryTRT(ulPath).addClass("horizontal-mega-menu").removeClass("vertical-mega-menu");
            jQueryTRT(ulPath + " ul.mm-submenu").removeAttr("style");
            jQueryTRT(ulPath + " .fa-minus-circle")
                .removeClass("fa-minus-circle")
                .addClass("fa-plus-circle");
            jQueryTRT(ulPath + " .submenu-opened").removeClass("submenu-opened");
            jQueryTRT(ulPath + " .toggle-menu-btn").hide();
            jQueryTRT(".horizontal-mega-menu>li.trt-menu-item").off();
            setTimeout(function () {
                jQueryTRT(ulPath)
                    .find(".trt-menu-item")
                    .each(function () {
                        setSubmenuBoundries(jQueryTRT(this));
                        setContactSubmenuBoundries(jQueryTRT(this));
                    });
            }, 1);
            jQueryTRT(ulPath).find(".trt-menu-item").unbind("onmouseover.simpleContactSubmenuResize");
            jQueryTRT(ulPath)
                .find(".trt-menu-item")
                .bind("onmouseover.simpleContactSubmenuResize", function () {
                    setSubmenuBoundries(jQueryTRT(this));
                    setContactSubmenuBoundries(jQueryTRT(this));
                });
            jQueryTRT(ulPath)
                .find("ul.mm-submenu.tabbed>li")
                .each(function () {
                    if (jQueryTRT(this).parent().find(".tab-opened").length == 0) {
                        /* jQueryTRT(this).parent().find(".tab-opened").removeClass("tab-opened"); */ jQueryTRT(this).addClass("tab-opened");
                        setTabbedSubmenuBoundries(jQueryTRT(this));
                    } else if (jQueryTRT(this).hasClass("tab-opened")) {
                        setTabbedSubmenuBoundries(jQueryTRT(this));
                    }
                });
            jQueryTRT(ulPath).find("ul.mm-submenu.tabbed>li").unbind();
            jQueryTRT(ulPath)
                .find("ul.mm-submenu.tabbed>li")
                .hover(function () {
                    jQueryTRT(this).parent().find(".tab-opened").removeClass("tab-opened");
                    jQueryTRT(this).addClass("tab-opened");
                    setTabbedSubmenuBoundries(jQueryTRT(this));
                });
            /* set first tab of every tabbed submenu be opened */ jQueryTRT(ulPath)
                .find("ul.mm-submenu.tabbed>li:first-child")
                .each(function () {
                    if (jQueryTRT(this).parent().find(".tab-opened").length == 0) {
                        jQueryTRT(this).addClass("tab-opened");
                        setTabbedSubmenuBoundries(jQueryTRT(this));
                    }
                });
            jQueryTRT(ulPath).find(".trt-menu-item").unbind("mouseenter.resizeSubmenus");
            jQueryTRT(ulPath)
                .find(".trt-menu-item")
                .bind("mouseenter.resizeSubmenus", function () {
                    setSubmenuBoundries(jQueryTRT(this));
                    setContactSubmenuBoundries(jQueryTRT(this));
                    if (jQueryTRT(this).find(".tab-opened").length > 0) {
                        setTabbedSubmenuBoundries(jQueryTRT(this).find(".tab-opened"));
                    }
                });
        } else {
            if (activateMegaMenu) {
                jQueryTRT(".mega-hover").removeClass("mega-hover");
                jQueryTRT(".trt-menu-item.disabled").removeClass("disabled");
                jQueryTRT(ulPath).addClass("vertical-mega-menu").removeClass("horizontal-mega-menu");
                jQueryTRT(ulPath + " .toggle-menu-btn").show();
                jQueryTRT(ulPath).find("li.trt-menu-item").off();
                jQueryTRT(ulPath).find("li.trt-menu-item a").off();
                var iconDistance = parseInt(jQueryTRT(ulPath + ">li>a").css("font-size"));
                var totalPaddingLeft = parseInt(jQueryTRT(ulPath + ">li").css("padding-left")) + parseInt(jQueryTRT(ulPath + ">li>a").css("padding-left"));
                var paddingLeftSubSubmenus = totalPaddingLeft;
                if (totalPaddingLeft > 15) {
                    paddingLeftSubSubmenus = 15;
                }
                var totalPaddingTop = parseInt(jQueryTRT(ulPath + ">li").css("padding-top")) + parseInt(jQueryTRT(ulPath + ">li>a").css("padding-top"));
                jQueryTRT("#verticalMenuSpacing").remove();
                var styleSheet = '<style id="verticalMenuSpacing" type="text/css">';
                styleSheet += ulPath + ".vertical-mega-menu>li>ul.mm-submenu.tree>li{padding-left:" + totalPaddingLeft + "px !important;padding-right:" + totalPaddingLeft + "px !important;}";
                styleSheet += ulPath + ".vertical-mega-menu>li>ul.mm-submenu.tree>li ul.mm-submenu li {padding-left:" + paddingLeftSubSubmenus + "px !important;padding-right:" + paddingLeftSubSubmenus + "px !important;}";
                styleSheet += ulPath + ".vertical-mega-menu>li ul.mm-submenu.simple>li{padding-left:" + totalPaddingLeft + "px !important;padding-right:" + totalPaddingLeft + "px !important;}";
                styleSheet += ulPath + ".vertical-mega-menu>li>ul.mm-submenu.tabbed>li{padding-left:" + totalPaddingLeft + "px !important;padding-right:" + totalPaddingLeft + "px !important;}";
                styleSheet += ulPath + ".vertical-mega-menu>li>ul.mm-submenu.tabbed>li>ul.mm-submenu>li {padding-left:" + paddingLeftSubSubmenus + "px !important;padding-right:" + paddingLeftSubSubmenus + "px !important;}";
                styleSheet += ulPath + ".vertical-mega-menu>li ul.mm-submenu.mm-contact>li{padding-left:" + totalPaddingLeft + "px !important;padding-right:" + totalPaddingLeft + "px !important;}";
                styleSheet += "</style>";
                jQueryTRT("head").append(styleSheet);
                /* remove tab-opened classes */ jQueryTRT(ulPath).find(".tab-opened").removeClass("tab-opened");
                jQueryTRT(ulPath).find(".trt-menu-item>a>.toggle-menu-btn").unbind("click.resizeSubmenus");
                jQueryTRT(ulPath)
                    .find(".trt-menu-item>a>.toggle-menu-btn")
                    .bind("click.resizeSubmenus", function () {
                        setSubmenuBoundries(jQueryTRT(this).parent().parent());
                        setContactSubmenuBoundries(jQueryTRT(this).parent().parent());
                    });
                jQueryTRT(ulPath).find(".trt-menu-item>.mm-submenu>li>a>.toggle-menu-btn").unbind("click.resizeTabbedSubmenu");
                jQueryTRT(ulPath)
                    .find(".trt-menu-item>.mm-submenu>li>a>.toggle-menu-btn")
                    .bind("click.resizeTabbedSubmenu", function () {
                        if (jQueryTRT(this).parent().parent().hasClass("mm-hovering")) {
                            setTabbedSubmenuBoundries(jQueryTRT(this).parent().parent());
                        }
                    });
                forceMobile = false;
            }
        }
        jQueryTRT(".submenu-opened").show();
        if (panelOpened) {
            jQueryTRT(".horizontal-mega-menu>.trt-menu-item").unbind("mouseenter.addMegaHoverClass");
            jQueryTRT(".horizontal-mega-menu>.trt-menu-item").bind("mouseenter.addMegaHoverClass", function () {
                jQueryTRT(".mega-hover").removeClass("mega-hover");
                if (panelOpened) {
                    jQueryTRT(this).addClass("mega-hover");
                }
            });
        } else {
            jQueryTRT(".mega-hover").removeClass("mega-hover");
        }
    }
    function renderMobileMenuForce(ulPathCustom) {
        jQueryTRT(".mega-hover").removeClass("mega-hover");
        jQueryTRT(".trt-menu-item.disabled").removeClass("disabled");
        jQueryTRT(ulPathCustom).addClass("vertical-mega-menu").removeClass("horizontal-mega-menu");
        jQueryTRT(ulPathCustom + " .toggle-menu-btn").show();
        jQueryTRT(ulPathCustom).find("li.trt-menu-item").off();
        jQueryTRT(ulPathCustom).find("li.trt-menu-item a").off();
        var iconDistance = parseInt(jQueryTRT(ulPathCustom + ">li>a").css("font-size"));
        var totalPaddingLeft = parseInt(jQueryTRT(ulPathCustom + ">li").css("padding-left")) + parseInt(jQueryTRT(ulPathCustom + ">li>a").css("padding-left"));
        var paddingLeftSubSubmenus = totalPaddingLeft;
        if (totalPaddingLeft > 15) {
            paddingLeftSubSubmenus = 15;
        }
        var totalPaddingTop = parseInt(jQueryTRT(ulPathCustom + ">li").css("padding-top")) + parseInt(jQueryTRT(ulPathCustom + ">li>a").css("padding-top"));
        jQueryTRT("#verticalMenuSpacing").remove();
        var styleSheet = '<style id="verticalMenuSpacing" type="text/css">';
        styleSheet += ulPathCustom + ".vertical-mega-menu>li>ul.mm-submenu.tree>li{padding-left:" + totalPaddingLeft + "px !important;padding-right:" + totalPaddingLeft + "px !important;}";
        styleSheet += ulPathCustom + ".vertical-mega-menu>li>ul.mm-submenu.tree>li ul.mm-submenu li {padding-left:" + paddingLeftSubSubmenus + "px !important;padding-right:" + paddingLeftSubSubmenus + "px !important;}";
        styleSheet += ulPathCustom + ".vertical-mega-menu>li ul.mm-submenu.simple>li{padding-left:" + totalPaddingLeft + "px !important;padding-right:" + totalPaddingLeft + "px !important;}";
        styleSheet += ulPathCustom + ".vertical-mega-menu>li>ul.mm-submenu.tabbed>li{padding-left:" + totalPaddingLeft + "px !important;padding-right:" + totalPaddingLeft + "px !important;}";
        styleSheet += ulPathCustom + ".vertical-mega-menu>li>ul.mm-submenu.tabbed>li>ul.mm-submenu>li {padding-left:" + paddingLeftSubSubmenus + "px !important;padding-right:" + paddingLeftSubSubmenus + "px !important;}";
        styleSheet += ulPathCustom + ".vertical-mega-menu>li ul.mm-submenu.mm-contact>li{padding-left:" + totalPaddingLeft + "px !important;padding-right:" + totalPaddingLeft + "px !important;}";
        styleSheet += "</style>";
        jQueryTRT("head").append(styleSheet);
        jQueryTRT(ulPathCustom).find(".tab-opened").removeClass("tab-opened");
        jQueryTRT(ulPathCustom).find(".trt-menu-item>a>.toggle-menu-btn").unbind("click.resizeSubmenus");
        jQueryTRT(ulPathCustom)
            .find(".trt-menu-item>a>.toggle-menu-btn")
            .bind("click.resizeSubmenus", function () {
                setSubmenuBoundries(jQueryTRT(this).parent().parent());
                setContactSubmenuBoundries(jQueryTRT(this).parent().parent());
            });
        jQueryTRT(ulPathCustom).find(".trt-menu-item>.mm-submenu>li>a>.toggle-menu-btn").unbind("click.resizeTabbedSubmenu");
        jQueryTRT(ulPathCustom)
            .find(".trt-menu-item>.mm-submenu>li>a>.toggle-menu-btn")
            .bind("click.resizeTabbedSubmenu", function () {
                if (jQueryTRT(this).parent().parent().hasClass("mm-hovering")) {
                    setTabbedSubmenuBoundries(jQueryTRT(this).parent().parent());
                }
            });
    }
    /* GENERATE MENU FUNCTIONS */ function concatClasses(newClasses, oldClasses) {
        if (oldClasses != "") {
            classes = oldClasses.split(" ");
        } else {
            classes = [];
        }
        if (newClasses != undefined && newClasses != "") {
            newClasses = newClasses.split(" ");
            jQueryTRT.each(newClasses, function (key, item) {
                if (jQueryTRT.inArray(item, classes) == -1) {
                    classes[classes.length] = item;
                }
            });
        }
        return classes.join(" ");
    }
    function getSpecificClasses(classes) {
        var specificClasses = [];
        if (classes != undefined) {
            classes = classes.split(" ");
            var commonClasses = "";
            jQueryTRT.each(classes, function (key, item) {
                if (item.indexOf("active") != -1 || item.indexOf("selected") != -1 || item.indexOf("current") != -1) {
                    specificClasses["active"] = item;
                } else if (item.indexOf("focus") != -1) {
                    specificClasses["focus"] = item;
                } else if (item.indexOf("first") != -1) {
                    specificClasses["first"] = item;
                } else if (item.indexOf("last") != -1) {
                    specificClasses["last"] = item;
                } else if (item.indexOf("trt") == -1 && item.indexOf("dropdown") == -1 && item.indexOf("mm-subopen") == -1 && item.indexOf("hidden") == -1 && item.indexOf("hide") == -1) {
                    commonClasses += " " + item;
                }
            });
            specificClasses["common"] = commonClasses.trim();
        }
        return specificClasses;
    }
    /* used to generate submenus */ function addSubMenus(parentItem, isSubTree) {
        var submenuHtml = "";
        if (parentItem.items != undefined && parentItem.items.length > 0) {
            if (parentItem.type == "link-list-image") {
                submenuHtml += '<ul class="mm-product-list">';
                jQueryTRT.each(parentItem.items, function (pos, subitem) {
                    var href = subitem.id != undefined && schemaLinksJSON[subitem.link] && schemaLinksJSON[subitem.link][subitem.id] ? schemaLinksJSON[subitem.link][subitem.id] : schemaLinksJSON[subitem.link];
                    var useOnClick = "";
                    if (window.self == window.top || (window.self !== window.top && window.name == "mega-menu-iframe")) {
                        useOnClick = 'onclick="return mmGoToPage(this)"';
                    }
                    if (subitem.link == "product" || subitem.link == "collection" || subitem.link == "article") {
                        var image = "";
                        if (subitem.link == "product" && productImages[subitem.id] != undefined && productImages[subitem.id].indexOf("no-image") == -1) {
                            image = '<div class="mm-list-image"><a data-href="' + href + '" href="' + href + '" ' + useOnClick + '"><img src="' + productImages[subitem.id] + '"></a></div>';
                        } else if (subitem.link == "collection" && collectionImages[subitem.id] != undefined && collectionImages[subitem.id].indexOf("no-image") == -1) {
                            image = '<div class="mm-list-image"><a data-href="' + href + '" href="' + href + '" ' + useOnClick + '"><img src="' + collectionImages[subitem.id] + '"></a></div>';
                            '<div class="mm-list-image"><img src="' + collectionImages[subitem.id] + '"></div>';
                        } else if (subitem.image != undefined) {
                            if (subitem.link == "article" && subitem.image.indexOf("/articles/") !== -1 && subitem.image.indexOf("_240x") == -1) {
                                subitem.image = subitem.image.replace(".jpg", "_240x.jpg").replace(".png", "_240x.png");
                            }
                            image = '<div class="mm-list-image"><a data-href="' + href + '" href="' + href + '" ' + useOnClick + '"><img src="' + subitem.image + '"></a></div>';
                        } else {
                            image = '<div class="mm-list-image"></div>';
                        }
                        var listInfo = "";
                        if (jQueryTRT.trim(subitem.name) != "") {
                            listInfo = '<div class="mm-list-info"><a data-href="' + href + '" class="mm-product-name" href="' + href + '">' + subitem.name.replace(/&quot;/g, '"') + "</a><br>";
                        }
                        if (subitem.link == "product" && subitem.id != undefined && prices[subitem.id] != undefined) {
                            listInfo += '<div class="mega-menu-prices">' + prices[subitem.id] + "</div>";
                        }
                        submenuHtml += "<li>" + image + listInfo + "</div>";
                    }
                    submenuHtml += "</li>";
                });
                submenuHtml += "</ul>";
            } else {
                var subMenuType = parentItem.type != undefined ? " " + parentItem.type : "";
                submenuHtml += '<ul class="mm-submenu' + subMenuType + '">';
                jQueryTRT.each(parentItem.items, function (pos, subitem) {
                    if (subitem.link == "no-link") {
                        var dataHref = "no-link";
                        var href = "#";
                    } else if (subitem.link == "http") {
                        var dataHref = subitem.http;
                        var href = subitem.http;
                    } else {
                        var dataHref = subitem.id != undefined && schemaLinksJSON[subitem.link] && schemaLinksJSON[subitem.link][subitem.id] ? schemaLinksJSON[subitem.link][subitem.id] : schemaLinksJSON[subitem.link];
                        var href = subitem.id != undefined && schemaLinksJSON[subitem.link] && schemaLinksJSON[subitem.link][subitem.id] ? schemaLinksJSON[subitem.link][subitem.id] : schemaLinksJSON[subitem.link];
                    }
                    var useOnClick = "";
                    if (window.self == window.top || (window.self !== window.top && window.name == "mega-menu-iframe")) {
                        useOnClick = 'onclick="return mmGoToPage(this)"';
                    }
                    if (parentItem.type == "simple") {
                        if (subitem.link == "best-sellers") {
                            submenuHtml += '<li><div class="mega-menu-item-container"><div class="mm-list-name"><span>' + subitem.name.replace(/&quot;/g, '"') + "</span></div>" + bestSellersHTML + "</div>";
                        } else if (subitem.link == "newest-products") {
                            submenuHtml += '<li><div class="mega-menu-item-container"><div class="mm-list-name"><span>' + subitem.name.replace(/&quot;/g, '"') + "</span></div>" + newestProductsHTML + "</div>";
                        } else if (subitem.link == "link-list") {
                            subitem.type = "link-list";
                            var linkList = addSubMenus(subitem);
                            submenuHtml += '<li><div class="mega-menu-item-container"><div class="mm-list-name"><span>' + subitem.name.replace(/&quot;/g, '"') + "</span></div>" + linkList + "</div>";
                        } else if (subitem.link == "link-list-image") {
                            subitem.type = "link-list-image";
                            var linkListImage = addSubMenus(subitem);
                            submenuHtml += '<li><div class="mega-menu-item-container"><div class="mm-list-name"><span class="name">' + subitem.name.replace(/&quot;/g, '"') + "</span></div>" + linkListImage + "</div>";
                        } else {
                            var image = "";
                            if (subitem.link == "product" && productImages[subitem.id] != undefined && productImages[subitem.id].indexOf("no-image") == -1) {
                                image =
                                    '<div class="mm-image-container"><div class="mm-image"><a data-href="' +
                                    dataHref +
                                    '" href="' +
                                    href +
                                    '" ' +
                                    useOnClick +
                                    ' aria-label="' +
                                    jQueryTRT("<div/>")
                                        .html(subitem.name.replace(/&quot;/g, '"'))
                                        .text() +
                                    '"><img src="' +
                                    productImages[subitem.id] +
                                    '"></a></div></div>';
                            } else if (subitem.link == "collection" && collectionImages[subitem.id] != undefined && collectionImages[subitem.id].indexOf("no-image") == -1) {
                                image =
                                    '<div class="mm-image-container"><div class="mm-image"><a data-href="' +
                                    dataHref +
                                    '" href="' +
                                    href +
                                    '" ' +
                                    useOnClick +
                                    ' aria-label="' +
                                    jQueryTRT("<div/>")
                                        .html(subitem.name.replace(/&quot;/g, '"'))
                                        .text() +
                                    '"><img src="' +
                                    collectionImages[subitem.id] +
                                    '"></a></div></div>';
                            } else if (subitem.image != undefined) {
                                if (subitem.link == "article" && subitem.image.indexOf("/articles/") !== -1 && subitem.image.indexOf("_240x") == -1) {
                                    subitem.image = subitem.image.replace(".jpg", "_240x.jpg").replace(".png", "_240x.png");
                                }
                                image =
                                    '<div class="mm-image-container"><div class="mm-image"><a data-href="' +
                                    dataHref +
                                    '" href="' +
                                    href +
                                    '" ' +
                                    useOnClick +
                                    ' aria-label="' +
                                    jQueryTRT("<div/>")
                                        .html(subitem.name.replace(/&quot;/g, '"'))
                                        .text() +
                                    '"><img src="' +
                                    subitem.image +
                                    '"></a></div></div>';
                            }
                            var pricesHTML = "";
                            if (subitem.link == "product" && subitem.id != undefined && prices[subitem.id] != undefined) {
                                pricesHTML = '<div class="mega-menu-prices">' + prices[subitem.id] + "</div>";
                            }
                            var nameHtml = "";
                            if (jQueryTRT.trim(subitem.name) != "") {
                                nameHtml +=
                                    '<a class="mm-featured-title" data-href="' +
                                    dataHref +
                                    '" href="' +
                                    href +
                                    '" ' +
                                    useOnClick +
                                    ' aria-label="' +
                                    jQueryTRT("<div/>")
                                        .html(subitem.name.replace(/&quot;/g, '"'))
                                        .text() +
                                    '">' +
                                    subitem.name.replace(/&quot;/g, '"') +
                                    "</a>";
                            }
                            submenuHtml += '<li><div class="mega-menu-item-container">' + image + nameHtml + pricesHTML + "</div>";
                        }
                    } else if (parentItem.type == "tree" || isSubTree) {
                        submenuHtml +=
                            '<li data-href="' +
                            dataHref +
                            '" ' +
                            useOnClick +
                            '><a data-href="' +
                            dataHref +
                            '" href="' +
                            href +
                            '" ' +
                            useOnClick +
                            ' aria-label="' +
                            jQueryTRT("<div/>")
                                .html(subitem.name.replace(/&quot;/g, '"'))
                                .text() +
                            '">' +
                            subitem.name.replace(/&quot;/g, '"') +
                            "</a>";
                    } else {
                        submenuHtml +=
                            '<li><a data-href="' +
                            dataHref +
                            '" href="' +
                            href +
                            '" ' +
                            useOnClick +
                            ' aria-label="' +
                            jQueryTRT("<div/>")
                                .html(subitem.name.replace(/&quot;/g, '"'))
                                .text() +
                            '">' +
                            subitem.name.replace(/&quot;/g, '"') +
                            "</a>";
                    }
                    /* set the simple menu type for each tab child */ if (parentItem.type == "tabbed") {
                        subitem.type = "simple";
                    }
                    if (subitem.link != "link-list" && subitem.link != "link-list-image") {
                        if (parentItem.type == "tree" || isSubTree) {
                            submenuHtml += addSubMenus(subitem, true);
                        } else {
                            submenuHtml += addSubMenus(subitem, false);
                        }
                    }
                    submenuHtml += "</li>";
                });
                submenuHtml += "</ul>";
            }
        }
        return submenuHtml;
    }
    /* TOOLTIP FUNCTIONS */ function undoAction() {
        currentUndo = undo[undo.length - 1];
        if (currentUndo.action == "design") {
            redo.unshift(currentUndo);
            schemaDesignJSON.splice(-1, 1);
            undo.splice(-1, 1);
            recreateDesign();
        }
        reinitMenus();
        /* if no mega menu present, remove theme scripts */ if (jQueryTRT(".trt-menu-item").length == 0) {
            jQueryTRT("#themeScript").remove();
        }
        if (window.self !== window.top) {
            var preview = parent;
            if (typeof parent.postMessage === "undefined") {
                preview = top;
            }
            preview.postMessage(["updateToolbar", JSON.stringify(schemaDesignJSON), JSON.stringify(linkLists), JSON.stringify(undo), JSON.stringify(redo), changedMenu], "*");
        } else if (previewPanelLoaded) {
            document
                .getElementById("mega-menu-iframe")
                .contentWindow.postMessage(["updateToolbar", JSON.stringify(schemaDesignJSON), JSON.stringify(linkLists), JSON.stringify(undo), JSON.stringify(redo), changedMenu], "https://trtapps.com");
        } /*}*/
    }
    function redoAction() {
        tempMenuObject = {};
        jQueryTRT(".trt-transparent").removeClass("trt-transparent");
        action = redo[0].action;
        if (action == "design") {
            schemaDesignJSON.push(redo[0]);
            undo.push(redo[0]);
            recreateDesign();
        }
        redo.splice(0, 1);
        reinitMenus();
        /* if no mega menu present, remove theme scripts */ if (jQueryTRT(".trt-menu-item").length == 0) {
            jQueryTRT("#themeScript").remove();
        }
        if (window.self !== window.top) {
            var preview = parent;
            if (typeof parent.postMessage === "undefined") {
                preview = top;
            }
            preview.postMessage(["updateToolbar", JSON.stringify(schemaDesignJSON), JSON.stringify(linkLists), JSON.stringify(undo), JSON.stringify(redo), changedMenu], "*");
        } else if (previewPanelLoaded) {
            document
                .getElementById("mega-menu-iframe")
                .contentWindow.postMessage(["updateToolbar", JSON.stringify(schemaDesignJSON), JSON.stringify(linkLists), JSON.stringify(undo), JSON.stringify(redo), changedMenu], "https://trtapps.com");
        } /*}*/
    }
    function clearAction() {
        jQueryTRT.each(undo, function (key, item) {
            undoAction();
        });
        redo = [];
        /* if no mega menu present, remove theme scripts */ if (jQueryTRT(".trt-menu-item").length == 0) {
            jQueryTRT("#themeScript").remove();
        }
        if (window.self !== window.top) {
            var preview = parent;
            if (typeof parent.postMessage === "undefined") {
                preview = top;
            }
            preview.postMessage(["updateToolbar", JSON.stringify(schemaDesignJSON), JSON.stringify(linkLists), JSON.stringify(undo), JSON.stringify(redo), changedMenu], "*");
        } else if (previewPanelLoaded) {
            document
                .getElementById("mega-menu-iframe")
                .contentWindow.postMessage(["updateToolbar", JSON.stringify(schemaDesignJSON), JSON.stringify(linkLists), JSON.stringify(undo), JSON.stringify(redo), changedMenu], "https://trtapps.com");
        } /*}*/
    }
    /* DESIGN */ /* .vertical-mega-menu li a ,.vertical-mega-menu li.fa */ /* var propSettings = {"background_color":{element:".horizontal-mega-menu ul.mm-submenu, .horizontal-mega-menu>li>ul.mm-submenu.tabbed>li>ul.mm-submenu li,.horizontal-mega-menu li.trt-menu-item:hover ul.mm-submenu.simple li:hover, .horizontal-mega-menu li.trt-menu-item.mega-hover ul.mm-submenu.simple li:hover",attribute:"background"},"background_hover_color":{element:".horizontal-mega-menu ul.mm-submenu.tree li:hover, .horizontal-mega-menu ul.mm-submenu.tree li.mega-hover, .horizontal-mega-menu ul.mm-submenu.tabbed>li.tab-opened",attribute:"background"},"text_color":{element:".horizontal-mega-menu ul.mm-submenu,.horizontal-mega-menu ul.mm-submenu li,.horizontal-mega-menu ul.mm-submenu h3",attribute:"color"},"link_color":{element:".horizontal-mega-menu ul.mm-submenu li a,.horizontal-mega-menu ul.mm-submenu li.fa",attribute:"color"},"link_hover_color":{element:".horizontal-mega-menu ul.mm-submenu.tree li:hover>a, .horizontal-mega-menu ul.mm-submenu.tree li.mega-hover>a, .horizontal-mega-menu ul.mm-submenu.tabbed>li.tab-opened>a, .horizontal-mega-menu ul.mm-submenu li a:hover, .horizontal-mega-menu ul.mm-submenu.tree li.fa:hover:before, .horizontal-mega-menu ul.mm-submenu.tree li.mega-hover.fa:before, .horizontal-mega-menu ul.mm-submenu.tabbed>li.tab-opened.fa:before",attribute:"color"},"font_size":{element:".horizontal-mega-menu ul.mm-submenu",attribute:"font-size"},"button_background_color":{element:"ul.mm-submenu li.mm-contact-column button",attribute:"background"},"button_background_hover_color":{element:"ul.mm-submenu li.mm-contact-column button:hover",attribute:"background"},"button_text_color":{element:"ul.mm-submenu li.mm-contact-column button",attribute:"color"},"button_text_hover_color":{element:"ul.mm-submenu li.mm-contact-column button:hover",attribute:"color"},"vertical_text_color":{element:".vertical-mega-menu ul.mm-submenu,.vertical-mega-menu ul.mm-submenu h3",attribute:"color"},"vertical_link_color":{element:".vertical-mega-menu ul.mm-submenu li a, .vertical-mega-menu ul.mm-submenu>li>a>.toggle-menu-btn>.fa",attribute:"color"},"vertical_link_hover_color":{element:".vertical-mega-menu ul.mm-submenu>li:hover>a, .vertical-mega-menu ul.mm-submenu.tree li:hover>a, .vertical-mega-menu ul.mm-submenu.tree li.mega-hover>a, .vertical-mega-menu ul.mm-submenu.tabbed>li.tab-opened>a, .vertical-mega-menu ul.mm-submenu li a:hover, .vertical-mega-menu ul.mm-submenu.tree li:hover>a>.toggle-menu-btn>.fa:before, .vertical-mega-menu ul.mm-submenu.tree li.mm-hovering>a>.toggle-menu-btn>.fa:before, .vertical-mega-menu ul.mm-submenu.tree li.mega-hover>a>.toggle-menu-btn>.fa:before, .vertical-mega-menu ul.mm-submenu.tabbed>li.mm-hovering>a>.toggle-menu-btn>.fa:before, .vertical-mega-menu ul.mm-submenu.tabbed>li:hover>a>.toggle-menu-btn>.fa:before, .vertical-mega-menu ul.mm-submenu li.mm-hovering>a",attribute:"color"},"vertical_font_size":{element:".vertical-mega-menu ul.mm-submenu,.vertical-mega-menu ul.mm-submenu.simple>li ul.mm-product-list>li .mm-list-info",attribute:"font-size"!!}; */ var propSettings = {
        background_color: {
            element:
                ".horizontal-mega-menu ul.mm-submenu, .horizontal-mega-menu>li>ul.mm-submenu.tabbed>li>ul.mm-submenu li,.horizontal-mega-menu li.trt-menu-item:hover ul.mm-submenu.simple li:hover, .horizontal-mega-menu li.trt-menu-item.mega-hover ul.mm-submenu.simple li:hover",
            attribute: "background",
        },
        background_hover_color: { element: ".horizontal-mega-menu ul.mm-submenu.tree li:hover, .horizontal-mega-menu ul.mm-submenu.tree li.mega-hover, .horizontal-mega-menu ul.mm-submenu.tabbed>li.tab-opened", attribute: "background" },
        text_color: { element: ".horizontal-mega-menu ul.mm-submenu,.horizontal-mega-menu ul.mm-submenu li,.horizontal-mega-menu ul.mm-submenu h3", attribute: "color" },
        link_color: {
            element:
                '.horizontal-mega-menu ul.mm-submenu li a,.horizontal-mega-menu ul.mm-submenu li.fa, .horizontal-mega-menu ul.mm-submenu.tree li:hover>a[data-href="no-link"], .horizontal-mega-menu ul.mm-submenu.tree li.mega-hover>a[data-href="no-link"], .horizontal-mega-menu ul.mm-submenu.tabbed>li.tab-opened>a[data-href="no-link"], .horizontal-mega-menu ul.mm-submenu li a[data-href="no-link"]:hover',
            attribute: "color",
        },
        link_hover_color: {
            element:
                ".horizontal-mega-menu ul.mm-submenu.tree li:hover>a, .horizontal-mega-menu ul.mm-submenu.tree li.mega-hover>a, .horizontal-mega-menu ul.mm-submenu.tabbed>li.tab-opened>a, .horizontal-mega-menu ul.mm-submenu li a:hover, .horizontal-mega-menu ul.mm-submenu.tree li.fa:hover:before, .horizontal-mega-menu ul.mm-submenu.tree li.mega-hover.fa:before, .horizontal-mega-menu ul.mm-submenu.tabbed>li.tab-opened.fa:before",
            attribute: "color",
        },
        font_size: { element: ".horizontal-mega-menu ul.mm-submenu,.horizontal-mega-menu ul.mm-submenu a", attribute: "font-size" },
        button_background_color: { element: "ul.mm-submenu li.mm-contact-column button", attribute: "background" },
        button_background_hover_color: { element: "ul.mm-submenu li.mm-contact-column button:hover", attribute: "background" },
        button_text_color: { element: "ul.mm-submenu li.mm-contact-column button", attribute: "color" },
        button_text_hover_color: { element: "ul.mm-submenu li.mm-contact-column button:hover", attribute: "color" },
        vertical_text_color: { element: ".vertical-mega-menu ul.mm-submenu,.vertical-mega-menu ul.mm-submenu h3", attribute: "color" },
        vertical_link_color: { element: ".vertical-mega-menu ul.mm-submenu li a, .vertical-mega-menu ul.mm-submenu>li>a>.toggle-menu-btn>.fa", attribute: "color" },
        vertical_link_hover_color: {
            element:
                ".vertical-mega-menu ul.mm-submenu>li:hover>a, .vertical-mega-menu ul.mm-submenu.tree li:hover>a, .vertical-mega-menu ul.mm-submenu.tree li.mega-hover>a, .vertical-mega-menu ul.mm-submenu.tabbed>li.tab-opened>a, .vertical-mega-menu ul.mm-submenu li a:hover, .vertical-mega-menu ul.mm-submenu.tree li:hover>a>.toggle-menu-btn>.fa:before, .vertical-mega-menu ul.mm-submenu.tree li.mm-hovering>a>.toggle-menu-btn>.fa:before, .vertical-mega-menu ul.mm-submenu.tree li.mega-hover>a>.toggle-menu-btn>.fa:before, .vertical-mega-menu ul.mm-submenu.tabbed>li.mm-hovering>a>.toggle-menu-btn>.fa:before, .vertical-mega-menu ul.mm-submenu.tabbed>li:hover>a>.toggle-menu-btn>.fa:before, .vertical-mega-menu ul.mm-submenu li.mm-hovering>a",
            attribute: "color",
        },
        vertical_font_size: { element: ".vertical-mega-menu ul.mm-submenu,.vertical-mega-menu ul.mm-submenu.simple>li ul.mm-product-list>li .mm-list-info", attribute: "font-size" },
        font_family: {
            element: ".horizontal-mega-menu ul.mm-submenu,.horizontal-mega-menu ul.mm-submenu li a,ul.mm-submenu a,.vertical-mega-menu ul.mm-submenu,.vertical-mega-menu ul.mm-submenu li a,ul.mm-submenu li.mm-contact-column h3",
            attribute: "font-family",
        },
        countdown_color: { element: ".trt-menu-item-countdown .inn", attribute: "color" },
        countdown_background_color: { element: ".trt-menu-item-countdown .inn,.trt-menu-item-countdown .up::after,.trt-menu-item-countdown .flip-clock-dot", attribute: "background" },
        countdown_menu_color: { element: ".trt-menu-item[countdown] > a", attribute: "color" },
    };
    function liveDesign(setting, value) {
        /* jQueryTRT(propSettings[setting].element).css(propSettings[setting].attribute,value); */ jQueryTRT("#tempStyle").remove();
        var styleSheet = '<style id="tempStyle" type="text/css">';
        styleSheet += propSettings[setting].element + "{" + propSettings[setting].attribute + ":" + value + " !important; }";
        /* add further css styling logic */ styleSheet += customPropSettingsStyles(setting, value);
        styleSheet += "</style>";
        jQueryTRT("head").append(styleSheet); /*}*/
    }
    var reinitAfterDesignTimeout;
    function updateDesign(setting, value) {
        jQueryTRT("#tempStyle").remove();
        item = {};
        item.action = "design";
        item.setting = setting;
        item.value = value;
        defaultFontSelected = false;
        if (item.setting == "font_family" && item.value == "Default") {
            defaultFontSelected = true;
        }
        schemaDesignJSON.push(item);
        undo.push(item);
        /* jQueryTRT(propSettings[setting].element).css(propSettings[setting].attribute,""); */ recreateDesign();
        if (setting == "font_size" || setting == "font_family") {
            jQueryTRT(".horizontal-mega-menu>.trt-menu-item>.mm-submenu").each(function () {
                if (parseInt(jQueryTRT(this).css("top")) > 0) {
                    setSubmenuBoundries(jQueryTRT(this).parent());
                    setContactSubmenuBoundries(jQueryTRT(this).parent());
                    if (jQueryTRT(this).hasClass("tabbed")) {
                        setTabbedSubmenuBoundries(jQueryTRT(this).find(">li.tab-opened"));
                    }
                }
            });
        }
        clearTimeout(reinitAfterDesignTimeout);
        reinitAfterDesignTimeout = setTimeout(function () {
            reinitMenus();
        }, 100);
        redo = [];
        if (window.self !== window.top) {
            var preview = parent;
            if (typeof parent.postMessage === "undefined") {
                preview = top;
            }
            preview.postMessage(["updateToolbar", JSON.stringify(schemaDesignJSON), JSON.stringify(linkLists), JSON.stringify(undo), JSON.stringify(redo), changedMenu], "*");
        } else if (previewPanelLoaded) {
            document
                .getElementById("mega-menu-iframe")
                .contentWindow.postMessage(["updateToolbar", JSON.stringify(schemaDesignJSON), JSON.stringify(linkLists), JSON.stringify(undo), JSON.stringify(redo), changedMenu], "https://trtapps.com");
        } /*}*/
    }
    function recreateDesign() {
        jQueryTRT("#previewStyle").remove();
        var styleSheet = '<style id="previewStyle" type="text/css">';
        jQueryTRT.each(schemaDesignJSON, function (key, item) {
            if (item.action == "design" && propSettings[item.setting] != undefined) {
                if (item.setting == "font_size") {
                    fontSize = parseInt(item.value);
                } else if (item.setting == "font_family") {
                    jQueryTRT("#googleFontDesign").remove();
                    if (item.value != "Default" && item.value != "Arial" && item.value != "Georgia" && item.value != "Tahoma" && item.value != "Trebuchet MS" && item.value != "Times New Roman" && item.value != "Verdana") {
                        var googleStyleSheet = '<link href="//fonts.googleapis.com/css?family=' + item.value + '" id="googleFontDesign" rel="stylesheet" type="text/css">';
                        jQueryTRT("head").append(googleStyleSheet);
                    }
                }
                if (item.setting != "font_family" || (item.setting == "font_family" && !defaultFontSelected && item.value != "Default")) {
                    styleSheet += propSettings[item.setting].element + "{" + propSettings[item.setting].attribute + ":" + item.value + " !important; }";
                }
                /* add further css styling logic*/ styleSheet += customPropSettingsStyles(item.setting, item.value);
            } else if (item.action == "design" && item.setting == "tree_sub_direction") {
                setTreeDirection = item.value;
                jQueryTRT(".horizontal-mega-menu>.trt-menu-item>.mm-submenu.tree").each(function () {
                    setSubmenuBoundries(jQueryTRT(this).parent());
                });
            }
        });
        styleSheet += "</style>";
        jQueryTRT("head").append(styleSheet);
    }
    function designPanelOpened() {
        panelOpened = true;
        if (jQueryTRT("ul.mm-submenu.tabbed").length > 0) {
            jQueryTRT(".horizontal-mega-menu:visible>.trt-menu-item>ul.mm-submenu.tabbed").each(function () {
                jQueryTRT(this).closest(".trt-menu-item").addClass("mega-hover");
                return false;
            });
        } else if (jQueryTRT("ul.mm-submenu.simple").length > 0) {
            jQueryTRT(".horizontal-mega-menu:visible>.trt-menu-item>ul.mm-submenu.simple").each(function () {
                jQueryTRT(this).closest(".trt-menu-item").addClass("mega-hover");
                return false;
            });
        } else if (jQueryTRT("ul.mm-submenu.contact").length > 0) {
            jQueryTRT(".horizontal-mega-menu:visible>.trt-menu-item>ul.mm-submenu.contact").each(function () {
                jQueryTRT(this).closest(".trt-menu-item").addClass("mega-hover");
                return false;
            });
        } else if (jQueryTRT("ul.mm-submenu.tree").length > 0) {
            jQueryTRT(".horizontal-mega-menu:visible>.trt-menu-item>ul.mm-submenu.tree").each(function () {
                jQueryTRT(this).closest(".trt-menu-item").addClass("mega-hover");
                return false;
            });
        }
        setSubmenuBoundries(jQueryTRT(".trt-menu-item.mega-hover"));
        setContactSubmenuBoundries(jQueryTRT(".trt-menu-item.mega-hover"));
        if (jQueryTRT("ul.mm-submenu.tabbed").length > 0) {
            setTabbedSubmenuBoundries(jQueryTRT(".trt-menu-item.mega-hover>ul.mm-submenu.tabbed>li:first-child"));
        }
        jQueryTRT(".horizontal-mega-menu>.trt-menu-item").hover(function () {
            jQueryTRT(".mega-hover").removeClass("mega-hover");
            if (panelOpened) {
                jQueryTRT(this).addClass("mega-hover");
            }
        });
    }
    function designPanelClosed() {
        panelOpened = false;
        jQueryTRT(".mega-hover").removeClass("mega-hover");
    }
    window.addEventListener("message", function (event) {
        /* if (window.self!==window.top) { */ if (~event.origin.indexOf("megamenu.trtapps.com")) {
            if (typeof event.data == "object") {
                if (event.data[0] == "applyMegaMenu") {
                    window[event.data[0]](event.data[1]);
                } else if (jQueryTRT.inArray(event.data[0], ["undoAction", "redoAction", "clearAction", "initSaving", "designPanelOpened", "designPanelClosed"]) !== -1) {
                    window[event.data[0]]();
                } else if (jQueryTRT.inArray(event.data[0], ["liveDesign", "updateDesign"]) !== -1) {
                    window[event.data[0]](event.data[1], event.data[2]);
                }
            } else {
                window[event.data]();
            }
        }
    });
    /* PAGE UNLOADING FUNCTIONS */ function initSaving() {
        jQueryTRT(".trt-loader-wrapper").show();
        jQueryTRT(".trt-loader-text").show();
        saving = true;
    }
    /* STORE FRONT FUNCTIONS */ /* used to open/close the vertical menu */ function toggleSubmenu(element) {
        if (!submenuToggled) {
            submenuToggled = true;
            var submenu = jQueryTRT(element).closest("li").find("ul.mm-submenu").first();
            if (!submenu.hasClass("submenu-opened")) {
                jQueryTRT(element).closest("li").addClass("mm-hovering");
                jQueryTRT(element).find(">.fa").removeClass("fa-plus-circle").addClass("fa-minus-circle");
                submenu.addClass("submenu-opened");
            } else {
                jQueryTRT(element).closest("li").removeClass("mm-hovering");
                jQueryTRT(element).find(">.fa").removeClass("fa-minus-circle").addClass("fa-plus-circle");
                submenu.removeClass("submenu-opened");
            }
            setTimeout(function () {
                submenuToggled = false;
            }, 400);
            jQueryTRT(document).trigger("toggleSubmenu", [element]);
        }
        return false;
    }
    function mmGoToPage(element, e) {
        if (!changingPage && !submenuToggled) {
            var hostName = window.location.hostname.replace("www.", "");
            var finalhost = hostName.substr(0, hostName.indexOf(".")) + ".";
            if (jQueryTRT(element).attr("data-href") != "no-link") {
                if (jQueryTRT(element).attr("data-href").indexOf("http") !== -1 && jQueryTRT(element).attr("data-href").indexOf(finalhost) === -1 && jQueryTRT(element).attr("data-href").indexOf("myshopify.com") === -1) {
                    changingPage = true;
                    var win = window.open(jQueryTRT(element).attr("data-href"), "_blank");
                    win.focus();
                    setTimeout(function () {
                        changingPage = false;
                    }, 300);
                } else {
                    changingPage = true;
                    window.location = jQueryTRT(element).attr("data-href");
                    setTimeout(function () {
                        changingPage = false;
                    }, 1000);
                }
            } else {
                e.stopPropagation();
            }
        }
        return false;
    }
    /* set the boundries of the submenus */ function setSubmenuBoundries(li) {
        var bodyWidth = jQueryTRT("body").width();
        var headerOffset = 1000;
        if (jQueryTRT(li).find(">ul.mm-submenu.simple").length > 0 || jQueryTRT(li).find(">ul.mm-submenu.tabbed").length > 0) {
            if (jQueryTRT(li).closest(".horizontal-mega-menu").length > 0) {
                /* get header offset */ /* IF YOU REMOVE .parent(). IT WILL AFFECT THE MENU FROM alex-woo-jewelry.myshopify.com */ jQueryTRT(li)
                    .parent()
                    .parents()
                    .each(function () {
                        var offsetLeft = jQueryTRT(this).offset().left + parseInt(jQueryTRT(this).css("padding-left"));
                        if (offsetLeft < headerOffset && offsetLeft > 0) {
                            headerOffset = offsetLeft;
                        }
                    });
                if (headerOffset == 1000 || bodyWidth <= 768) {
                    headerOffset = 0;
                }
                /* if (customHeaderOffset && customHeaderOffset<bodyWidth) { headerOffset = (bodyWidth-customHeaderOffset)/2; } MADE THE BELOW MODIFICATION FOR CLIENT https://www.mwfundraising.com/ */ if (customHeaderOffset) {
                    if (customHeaderOffset < bodyWidth) {
                        headerOffset = (bodyWidth - customHeaderOffset) / 2;
                    } else {
                        headerOffset = 0;
                    }
                }
                /* set menu width */ if (jQueryTRT(li).find(">ul.mm-submenu.simple").length > 0) {
                    var submenu = jQueryTRT(li).find(">ul.mm-submenu.simple");
                } else {
                    var submenu = jQueryTRT(li).find(">ul.mm-submenu.tabbed");
                }
                submenu.css({ width: "auto", left: "auto", right: "auto" });
                /*submenu.removeAttr("style"); submenu.find(">li").removeAttr("style");*/ if (headerOffset * 2 > bodyWidth) {
                    headerOffset = 0;
                }
                var headerWidth = bodyWidth - headerOffset * 2;
                var itemsPerRow = 5;
                if (headerWidth >= 1020) {
                    /* submenu.attr("columns",5).css("width",headerWidth+"px"); */ var style = submenu.attr("columns", 5).attr("style");
                    style += "width:" + headerWidth + "px !important;";
                    submenu.attr("style", style);
                    itemsPerRow = 5;
                } else if (headerWidth >= 816) {
                    var style = submenu.attr("columns", 4).attr("style");
                    style += "width:" + headerWidth + "px !important;";
                    submenu.attr("style", style);
                    itemsPerRow = 4;
                } else if (headerWidth >= 612) {
                    var style = submenu.attr("columns", 3).attr("style");
                    style += "width:" + headerWidth + "px !important;";
                    submenu.attr("style", style);
                    itemsPerRow = 3;
                } else {
                    var style = submenu.attr("columns", 2).attr("style");
                    style += "width:" + headerWidth + "px !important;";
                    submenu.attr("style", style);
                    itemsPerRow = 2;
                }
                if (jQueryTRT(li).find(">ul.mm-submenu.tabbed").length > 0) {
                    --itemsPerRow;
                }
                /* set simple submenu boundry */ var offsetLeft = jQueryTRT(li).offset().left + jQueryTRT(li).outerWidth() / 2;
                if (offsetLeft < bodyWidth / 2) {
                    var left = bodyWidth - (bodyWidth - jQueryTRT(li).offset().left) - headerOffset;
                    submenu.css("left", -left + "px");
                } else {
                    var right = bodyWidth - jQueryTRT(li).offset().left - jQueryTRT(li).outerWidth() - headerOffset;
                    submenu.css("right", -right + "px");
                }
                /* set min height for each element */ jQueryTRT(li).find("ul.mm-submenu.simple>li").removeAttr("style");
                jQueryTRT(li).find(".mm-list-name").removeAttr("style");
                /* if simple menu */ if (jQueryTRT(li).find(">ul.mm-submenu.simple").length > 0) {
                    var rowMinHeight = 0;
                    var mmListNameHeight = 0;
                    if (fontSize <= 14) {
                        fontSize = 8;
                    } else if (fontSize > 14 && fontSize <= 18) {
                        fontSize += 6;
                    } else if (fontSize > 18 && fontSize <= 20) {
                        fontSize += 10;
                    }
                    jQueryTRT(li)
                        .find("ul.mm-submenu.simple>li")
                        .each(function (i, item) {
                            if (i % itemsPerRow == 0) {
                                rowMinHeight = 0;
                                mmListNameHeight = 0;
                            }
                            if (jQueryTRT(this).find(".mm-list-name").length > 0) {
                                if (jQueryTRT(this).find(".mm-list-name").height() > mmListNameHeight) {
                                    mmListNameHeight = jQueryTRT(this).find(".mm-list-name").height();
                                    jQueryTRT(this).find(".mm-list-name").css("height", mmListNameHeight);
                                    var previousItems = i;
                                    if (previousItems % itemsPerRow != 0) {
                                        while (previousItems % itemsPerRow != 0) {
                                            jQueryTRT(li)
                                                .find("ul.mm-submenu.simple")
                                                .find(">li:nth-child(" + previousItems + ")")
                                                .find(".mm-list-name")
                                                .css("height", mmListNameHeight);
                                            previousItems--;
                                        }
                                    }
                                } else {
                                    jQueryTRT(this).find(".mm-list-name").css("height", mmListNameHeight);
                                }
                            }
                            if (jQueryTRT(this).outerHeight() > rowMinHeight) {
                                rowMinHeight = jQueryTRT(this).outerHeight();
                                jQueryTRT(this).css("min-height", rowMinHeight + fontSize);
                                var previousItems = i;
                                if (previousItems % itemsPerRow != 0) {
                                    while (previousItems % itemsPerRow != 0) {
                                        jQueryTRT(li)
                                            .find("ul.mm-submenu.simple")
                                            .find(">li:nth-child(" + previousItems + ")")
                                            .css("min-height", rowMinHeight + fontSize);
                                        previousItems--;
                                    }
                                }
                            } else {
                                jQueryTRT(this).css("min-height", rowMinHeight + fontSize);
                            }
                        }); /* if tabbed menu */
                } else {
                    jQueryTRT(li)
                        .find("ul.mm-submenu.tabbed>li")
                        .each(function (i, tab) {
                            var rowMinHeight = 0;
                            var mmListNameHeight = 0;
                            if (fontSize <= 14) {
                                fontSize = 6;
                            } else if (fontSize > 14 && fontSize <= 18) {
                                fontSize += 2;
                            } else if (fontSize > 18 && fontSize <= 20) {
                                fontSize += 6;
                            }
                            jQueryTRT(tab)
                                .find("ul.mm-submenu.simple>li")
                                .each(function (j, item) {
                                    if (j % itemsPerRow == 0) {
                                        rowMinHeight = 0;
                                        mmListNameHeight = 0;
                                    }
                                    if (jQueryTRT(this).find(".mm-list-name").length > 0) {
                                        if (jQueryTRT(this).find(".mm-list-name").height() > mmListNameHeight) {
                                            mmListNameHeight = jQueryTRT(this).find(".mm-list-name").height();
                                            jQueryTRT(this).find(".mm-list-name").css("height", mmListNameHeight);
                                            var previousItems = j;
                                            if (previousItems % itemsPerRow != 0) {
                                                while (previousItems % itemsPerRow != 0) {
                                                    jQueryTRT(this)
                                                        .parent()
                                                        .find(">li:nth-child(" + previousItems + ")")
                                                        .find(".mm-list-name")
                                                        .css("height", mmListNameHeight);
                                                    previousItems--;
                                                }
                                            }
                                        } else {
                                            jQueryTRT(this).find(".mm-list-name").css("height", mmListNameHeight);
                                        }
                                    }
                                    if (jQueryTRT(this).outerHeight() > rowMinHeight) {
                                        rowMinHeight = jQueryTRT(this).outerHeight();
                                        jQueryTRT(this).css("min-height", rowMinHeight + fontSize);
                                        var previousItems = j;
                                        if (previousItems % itemsPerRow != 0) {
                                            while (previousItems % itemsPerRow != 0) {
                                                jQueryTRT(tab)
                                                    .find(">ul.mm-submenu.simple")
                                                    .find(">li:nth-child(" + previousItems + ")")
                                                    .css("min-height", rowMinHeight + fontSize);
                                                previousItems--;
                                            }
                                        }
                                    } else {
                                        jQueryTRT(this).css("min-height", rowMinHeight + fontSize);
                                    }
                                });
                        });
                    /* add arrows */ jQueryTRT(li).find("ul.mm-submenu.tabbed>li").addClass("fa fa-angle-right");
                }
            } else {
                jQueryTRT(li).find("ul.mm-submenu.tabbed").css({ left: "auto", right: "auto" });
                var currentStyle = jQueryTRT(li).find("ul.mm-submenu.tabbed").attr("style");
                var newStyle = "";
                if (currentStyle != undefined) {
                    newStyle += currentStyle + ";height:auto !important;width:auto !important";
                } else {
                    newStyle += "height:auto !important;width:auto !important";
                }
                jQueryTRT(li).find("ul.mm-submenu.tabbed").attr("style", newStyle);
                jQueryTRT(li).find("ul.mm-submenu.simple").css({ left: "auto", right: "auto" });
                var currentStyle = jQueryTRT(li).find("ul.mm-submenu.simple").attr("style");
                var newStyle = "";
                if (currentStyle != undefined) {
                    newStyle += currentStyle + ";width:auto !important";
                } else {
                    newStyle += ";width:auto !important";
                }
                jQueryTRT(li).find("ul.mm-submenu.simple").attr("style", newStyle);
                jQueryTRT(li).find("ul.mm-submenu.simple>li").removeAttr("style");
                if (jQueryTRT(li).width() >= 700) {
                    jQueryTRT(li).find("ul.mm-submenu.simple").attr("columns", 3);
                    jQueryTRT(".vertical-mega-menu ul.mm-submenu.mm-contact").attr("columns", 2);
                } else if (jQueryTRT(li).width() >= 500) {
                    jQueryTRT(li).find("ul.mm-submenu.simple").attr("columns", 2);
                    jQueryTRT(".vertical-mega-menu ul.mm-submenu.mm-contact").attr("columns", 2);
                } else {
                    jQueryTRT(li).find("ul.mm-submenu.simple").removeAttr("columns");
                    jQueryTRT(".vertical-mega-menu ul.mm-submenu.mm-contact").removeAttr("columns");
                }
            }
        } else if (jQueryTRT(li).find("ul.mm-submenu.tree").length > 0) {
            jQueryTRT(li).find("ul.mm-submenu").removeAttr("style");
            /* tree direction var start if(setTreeDirection == "set_tree_right") { jQueryTRT(li).find("ul.mm-submenu").removeClass("tree-open-left"); jQueryTRT(li).find("ul.mm-submenu.tree li").removeClass("fa fa-angle-right fa-angle-left"); jQueryTRT(li).find("ul.mm-submenu.tree li").each(function(){ if (jQueryTRT(this).find("ul.mm-submenu").length>0) { jQueryTRT(this).addClass("fa fa-angle-right"); } }); } else if(setTreeDirection == "set_tree_left") { jQueryTRT(li).find("ul.mm-submenu").addClass("tree-open-left"); jQueryTRT(li).find("ul.mm-submenu.tree li").removeClass("fa fa-angle-right fa-angle-left"); jQueryTRT(li).find("ul.mm-submenu.tree li").each(function(){ if (jQueryTRT(this).find("ul.mm-submenu").length>0) { jQueryTRT(this).addClass("fa fa-angle-left"); } }); } else if(setTreeDirection == "set_tree_auto") { tree direction var end */ /* on touch devices refresh tree direction only on main menu item touch, not on children touch. avoids tree direction issues on 3 level menus. same behavior is on desktop hover. */ if (
                jQueryTRT(li).parents(".trt-menu-item.mega-hover").length == 0
            ) {
                var offsetLeft = jQueryTRT(li).offset().left + jQueryTRT(li).outerWidth() / 2;
                if ((offsetLeft < bodyWidth / 2 && (setTreeDirection == "set_tree_auto" || setTreeDirection == undefined)) || setTreeDirection == "set_tree_right") {
                    jQueryTRT(li).find("ul.mm-submenu").removeClass("tree-open-left");
                    jQueryTRT(li).find("ul.mm-submenu.tree li").removeClass("fa fa-angle-right fa-angle-left");
                    jQueryTRT(li)
                        .find("ul.mm-submenu.tree li")
                        .each(function () {
                            if (jQueryTRT(this).find("ul.mm-submenu").length > 0) {
                                jQueryTRT(this).addClass("fa fa-angle-right");
                            }
                        });
                } else {
                    jQueryTRT(li).find("ul.mm-submenu").addClass("tree-open-left");
                    jQueryTRT(li).find("ul.mm-submenu.tree li").removeClass("fa fa-angle-right fa-angle-left");
                    jQueryTRT(li)
                        .find("ul.mm-submenu.tree li")
                        .each(function () {
                            if (jQueryTRT(this).find("ul.mm-submenu").length > 0) {
                                jQueryTRT(this).addClass("fa fa-angle-left");
                            }
                        });
                }
            }
        }
    }
    /* when you hover over the tabs of the tabbed submenu, open their submenu + readjust the height of the tabbed submenu */ function setTabbedSubmenuBoundries(li) {
        if (jQueryTRT(li).closest(".horizontal-mega-menu").length > 0) {
            /* reset the boundries of the simple submenu, because it wasn"t visible before */ if (allowMainMenuRecalibration) {
                setSubmenuBoundries(jQueryTRT(li).closest(".trt-menu-item"));
            }
            /* set the tabbed submenu height */ var currentLi = jQueryTRT(li).parent().find(">li").index(jQueryTRT(li));
            if (jQueryTRT(li).find(">ul.mm-submenu").length > 0) {
                jQueryTRT(li).find(">ul.mm-submenu").removeAttr("style");
                var tabbedSubmenuHeight = jQueryTRT(li).find(">ul.mm-submenu").outerHeight();
                var tabsHeight = 0;
                jQueryTRT(li)
                    .parent()
                    .find(">li")
                    .each(function () {
                        tabsHeight += jQueryTRT(this).outerHeight();
                    });
                if (tabsHeight > tabbedSubmenuHeight) {
                    /* jQueryTRT(li).parent().css("height",tabsHeight+"px"); */ var currentStyle = jQueryTRT(li).parent().attr("style");
                    var newStyle = "";
                    if (currentStyle != undefined) {
                        newStyle += currentStyle + ";height:" + tabsHeight + "px !important";
                    } else {
                        newStyle += "height:" + tabsHeight + "px !important";
                    }
                    jQueryTRT(li).parent().attr("style", newStyle);
                    /* jQueryTRT(li).find(">ul.mm-submenu").css("height",tabsHeight+"px"); */ var currentStyle = jQueryTRT(li).find(">ul.mm-submenu").attr("style");
                    var newStyle = "";
                    if (currentStyle != undefined) {
                        newStyle += currentStyle + ";height:" + tabsHeight + "px !important";
                    } else {
                        newStyle += "height:" + tabsHeight + "px !important";
                    }
                    jQueryTRT(li).find(">ul.mm-submenu").attr("style", newStyle);
                } else {
                    /* jQueryTRT(li).parent().css("height",tabbedSubmenuHeight+"px"); */ var currentStyle = jQueryTRT(li).parent().attr("style");
                    var newStyle = "";
                    if (currentStyle != undefined) {
                        newStyle += currentStyle + ";height:" + tabbedSubmenuHeight + "px !important";
                    } else {
                        newStyle += "height:" + tabbedSubmenuHeight + "px !important";
                    }
                    jQueryTRT(li).parent().attr("style", newStyle);
                }
            } else {
                jQueryTRT(li).parent().css("height", "auto");
            }
            /* set the simple submenu top */ var top = jQueryTRT(li)
                .parent()
                .find(">li:nth-child(" + (currentLi + 1) + ")")
                .position().top;
            var currentStyle = jQueryTRT(li).find(">ul.mm-submenu").attr("style");
            var newStyle = "";
            if (currentStyle != undefined) {
                newStyle += currentStyle + ";top:-" + top + "px !important";
            } else {
                newStyle += "top:-" + top + "px !important";
            }
            jQueryTRT(li).find(">ul.mm-submenu").attr("style", newStyle);
        } else {
            jQueryTRT(li).closest(".vertical-mega-menu").find(".tab-opened").removeClass("tab-opened"); /* jQueryTRT(".tab-opened").removeClass("tab-opened"); */
        }
    }
    /* set the boundries of the contact submenus */ function setContactSubmenuBoundries(li) {
        var bodyWidth = jQueryTRT("body").width();
        var headerOffset = 1000;
        if (jQueryTRT(li).find(">ul.mm-submenu.mm-contact").length > 0 && jQueryTRT(li).closest(".horizontal-mega-menu").length > 0) {
            /* get header offset */ jQueryTRT(li)
                .parent()
                .parents()
                .each(function () {
                    var offsetLeft = jQueryTRT(this).offset().left + parseInt(jQueryTRT(this).css("padding-left"));
                    if (offsetLeft < headerOffset && offsetLeft > 0) {
                        headerOffset = offsetLeft;
                    }
                });
            if (headerOffset == 1000) {
                headerOffset = 0;
            }
            if (headerOffset * 2 > bodyWidth) {
                headerOffset = 0;
            }
            if (customHeaderOffset) {
                if (customHeaderOffset < bodyWidth) {
                    headerOffset = (bodyWidth - customHeaderOffset) / 2;
                } else {
                    headerOffset = 0;
                }
            }
            /* set menu width */ var submenu = jQueryTRT(li).find(">ul.mm-submenu.mm-contact");
            var headerWidth = bodyWidth - headerOffset * 2;
            submenu.css({ width: headerWidth + "px", left: "auto", right: "auto" });
            /* set simple submenu boundry */ var offsetLeft = jQueryTRT(li).offset().left + jQueryTRT(li).outerWidth() / 2;
            if (offsetLeft < bodyWidth / 2) {
                var left = bodyWidth - (bodyWidth - jQueryTRT(li).offset().left) - headerOffset;
                submenu.css("left", -left + "px");
            } else {
                var right = bodyWidth - jQueryTRT(li).offset().left - jQueryTRT(li).outerWidth() - headerOffset;
                submenu.css("right", -right + "px");
            }
        } else {
            jQueryTRT(li).find("ul.mm-submenu.mm-contact").css({ left: "auto", right: "auto", width: "auto", height: "auto" });
            if (jQueryTRT(li).find(">ul.mm-submenu.mm-contact").width() <= 480) {
                jQueryTRT(li).find(">ul.mm-submenu.mm-contact").addClass("one-column");
            }
        }
    }
    function addTouch() {
        /* when touching outside close the submenu */ touched = false;
        if (globalTouch) {
            jQueryTRT("*").off("touchend.mm-all-dom-elements");
            jQueryTRT("*").on("touchend.mm-all-dom-elements", function (e) {
                if (jQueryTRT(this).closest(".trt-menu-item").length == 0) {
                    jQueryTRT(".mega-hover").removeClass("mega-hover");
                }
            });
        }
        var elementTouched = false;
        jQueryTRT(".vertical-mega-menu li").off("touchstart.mm-vertical-li");
        jQueryTRT(".vertical-mega-menu li").on("touchstart.mm-vertical-li", function (e) {
            elementTouched = false;
        });
        jQueryTRT(".vertical-mega-menu li").off("touchmove.mm-vertical-li");
        jQueryTRT(".vertical-mega-menu li").on("touchmove.mm-vertical-li", function (e) {
            elementTouched = true;
        });
        jQueryTRT(".vertical-mega-menu li").off("touchend.mm-vertical-li");
        jQueryTRT(".vertical-mega-menu li").on("touchend.mm-vertical-li", function (e) {
            "use strict";
            if (!elementTouched) {
                elementTouched = true;
                setTimeout(function () {
                    elementTouched = false;
                }, 300);
                var li = jQueryTRT(this);
                if (li.find("ul.mm-submenu").length > 0) {
                    if (li.hasClass("mm-hovering")) {
                        return true;
                    } else {
                        e.preventDefault();
                        if (li.find(">a>.toggle-menu-btn").length > 0) {
                            li.find(">a>.toggle-menu-btn").click();
                        } else if (li.find(">a>span>.toggle-menu-btn").length > 0) {
                            li.find(">a>span>.toggle-menu-btn").click();
                        }
                        return false;
                    }
                } else {
                    /* ignore countdown li-s but keep propagation to trigger mainmenuitem touch */ if (li.parents(".trt-menu-item-countdown").length > 0) {
                        e.preventDefault();
                        elementTouched = false;
                    } else {
                        setTimeout(function () {
                            if (!changingPage) {
                                li.find("a").first().click();
                            }
                        }, 200);
                    }
                    return true;
                }
            }
        });
        var elementTouched2 = false;
        jQueryTRT(".horizontal-mega-menu li").off("touchstart.mm-horizontal-li");
        jQueryTRT(".horizontal-mega-menu li").on("touchstart.mm-horizontal-li", function (e) {
            elementTouched2 = false;
        });
        jQueryTRT(".horizontal-mega-menu li").off("touchmove.mm-horizontal-li");
        jQueryTRT(".horizontal-mega-menu li").on("touchmove.mm-horizontal-li", function (e) {
            elementTouched2 = true;
        });
        jQueryTRT(".horizontal-mega-menu li").off("touchend.mm-horizontal-li");
        jQueryTRT(".horizontal-mega-menu li").on("touchend.mm-horizontal-li", function (e) {
            "use strict";
            /* ignore non taps */ if (!elementTouched2) {
                elementTouched2 = true;
                setTimeout(function () {
                    elementTouched2 = false;
                }, 300);
                var li = jQueryTRT(this);
                /* tap on main menu items with children first tap => add the hover class and redraw second tap => perform default action */ if (li.is(".trt-menu-item")) {
                    if (li.find("ul.mm-submenu").length > 0) {
                        if (li.hasClass("mega-hover")) {
                            mmGoToPage(li.find("a").first(), e);
                            return true;
                        } else {
                            e.preventDefault();
                            jQueryTRT(".mega-hover").removeClass("mega-hover");
                            li.addClass("mega-hover");
                            setSubmenuBoundries(li);
                            setContactSubmenuBoundries(li);
                            if (li.find(".tab-opened").length > 0) {
                                setTabbedSubmenuBoundries(li.find(".tab-opened"));
                            }
                            return false;
                        }
                    } else {
                        return true;
                    } /* tap on tabbed menu: first tap => open tab second tap => default action */
                } else if (li.parent().is(".mm-submenu.tabbed")) {
                    if (li.find("ul.mm-submenu").length > 0) {
                        if (li.hasClass("tab-opened")) {
                            mmGoToPage(li.find("a").first(), e);
                            return true;
                        } else {
                            e.preventDefault();
                            li.parent().find(">li").removeClass("tab-opened");
                            li.addClass("tab-opened");
                            setTabbedSubmenuBoundries(li);
                            setSubmenuBoundries(li.parent().parent());
                            return false;
                        }
                    } else {
                        return true;
                    } /* tap on tree menu with children: first tap => open sub tree second tap => default action */
                } else if (li.parents(".mm-submenu.tree").length > 0 && li.find("ul.mm-submenu").length > 0) {
                    if (li.hasClass("mega-hover")) {
                        mmGoToPage(li.find("a").first(), e);
                        return true;
                    } else {
                        e.preventDefault();
                        li.parent().find(">li").removeClass("mega-hover");
                        li.addClass("mega-hover");
                        li.find(".mega-hover").removeClass("mega-hover");
                        jQueryTRT.each(li.parents(), function () {
                            if (jQueryTRT(this).prop("tagName").toLowerCase() == "li") {
                                jQueryTRT(this).addClass("mega-hover");
                            }
                        });
                        setSubmenuBoundries(li);
                        return false;
                    } /* ignore countdown li-s but keep propagation to trigger mainmenuitem touch */
                } else if (li.parents(".trt-menu-item-countdown").length > 0) {
                    e.preventDefault();
                    elementTouched2 = false;
                    return true; /* ignore contact */
                } else if (li.parents(".mm-contact").length > 0) {
                    e.stopPropagation();
                    return true; /* all other menu li types: open the page */
                } else {
                    mmGoToPage(li.find("a").first(), e);
                    return true;
                }
            }
        });
    }
    function addTouch2() {
        var mmTouchState = "idle";
        var mmTouchY;
        jQueryTRT(document).on("touchstart.mm-li", function (e) {
            mmTouchState = "tap";
            mmTouchY = jQueryTRT(e.target).offset().top;
            setTimeout(function () {
                if (mmTouchState == "tap") mmTouchState = "touch";
            }, 150);
        });
        var executed = false;
        jQueryTRT(document).off("touchend.mm-li");
        jQueryTRT(document).on("touchend.mm-li", function (e) {
            /* when touching outside close the submenu */ if (globalTouch) {
                if (jQueryTRT(e.target).closest(".trt-menu-item").length == 0) {
                    jQueryTRT(".mega-hover").removeClass("mega-hover");
                }
            }
            var pointerNotMoved = Math.abs(mmTouchY - jQueryTRT(e.target).offset().top) < 1;
            if (mmTouchState == "tap" && pointerNotMoved && !executed) {
                if (jQueryTRT(e.target).closest(".vertical-mega-menu li").length > 0) {
                    ("use strict");
                    var li = jQueryTRT(e.target).closest("li");
                    if (li.find("ul.mm-submenu").length > 0) {
                        if (li.hasClass("mm-hovering")) {
                            return true;
                        } else {
                            e.preventDefault();
                            if (li.find(">a>.toggle-menu-btn").length > 0) {
                                li.find(">a>.toggle-menu-btn").click();
                            } else if (li.find(">a>span>.toggle-menu-btn").length > 0) {
                                li.find(">a>span>.toggle-menu-btn").click();
                            }
                            return false;
                        }
                    } else {
                        /* ignore countdown li-s but keep propagation to trigger mainmenuitem touch */ if (li.parents(".trt-menu-item-countdown").length > 0) {
                            e.preventDefault();
                        } else {
                            setTimeout(function () {
                                if (!changingPage) {
                                    li.find("a").first().click();
                                }
                            }, 200);
                        }
                        return true;
                    }
                } else if (jQueryTRT(e.target).closest(".horizontal-mega-menu li").length > 0) {
                    ("use strict");
                    var li = jQueryTRT(e.target).closest("li");
                    /* tap on main menu items with children first tap => add the hover class and redraw second tap => perform default action */ if (li.is(".trt-menu-item")) {
                        if (li.find("ul.mm-submenu").length > 0) {
                            if (li.hasClass("mega-hover")) {
                                mmGoToPage(li.find("a").first(), e);
                                return true;
                            } else {
                                e.preventDefault();
                                jQueryTRT(".mega-hover").removeClass("mega-hover");
                                li.addClass("mega-hover");
                                setSubmenuBoundries(li);
                                setContactSubmenuBoundries(li);
                                if (li.find(".tab-opened").length > 0) {
                                    setTabbedSubmenuBoundries(li.find(".tab-opened"));
                                }
                                return false;
                            }
                        } else {
                            return true;
                        } /* tap on tabbed menu: first tap => open tab second tap => default action */
                    } else if (li.parent().is(".mm-submenu.tabbed")) {
                        if (li.find("ul.mm-submenu").length > 0) {
                            if (li.hasClass("tab-opened")) {
                                mmGoToPage(li.find("a").first(), e);
                                return true;
                            } else {
                                e.preventDefault();
                                li.parent().find(">li").removeClass("tab-opened");
                                li.addClass("tab-opened");
                                setTabbedSubmenuBoundries(li);
                                setSubmenuBoundries(li.parent().parent());
                                return false;
                            }
                        } else {
                            return true;
                        } /* tap on tree menu with children: first tap => open sub tree second tap => default action */
                    } else if (li.parents(".mm-submenu.tree").length > 0 && li.find("ul.mm-submenu").length > 0) {
                        if (li.hasClass("mega-hover")) {
                            mmGoToPage(li.find("a").first(), e);
                            return true;
                        } else {
                            e.preventDefault();
                            li.parent().find(">li").removeClass("mega-hover");
                            li.addClass("mega-hover");
                            li.find(".mega-hover").removeClass("mega-hover");
                            jQueryTRT.each(li.parents(), function () {
                                if (jQueryTRT(this).prop("tagName").toLowerCase() == "li") {
                                    jQueryTRT(this).addClass("mega-hover");
                                }
                            });
                            setSubmenuBoundries(li);
                            return false;
                        } /* ignore countdown li-s but keep propagation to trigger mainmenuitem touch */
                    } else if (li.parents(".trt-menu-item-countdown").length > 0) {
                        e.preventDefault();
                        return true; /* ignore contact */
                    } else if (li.parents(".mm-contact").length > 0) {
                        e.stopPropagation();
                        return true; /* all other menu li types: open the page */
                    } else {
                        mmGoToPage(li.find("a").first(), e);
                        return true;
                    }
                }
            }
            mmTouchState = "idle";
            executed = true;
            setTimeout(function () {
                /* prevent multiple touchends */ executed = false;
            }, 150);
        });
    }
    function getUlPath(element) {
        var path,
            node = element;
        var firstNode = true;
        while (node.length) {
            var realNode = node[0],
                name = realNode.localName;
            if (!name) break;
            name = name.toLowerCase();
            var parent = node.parent();
            var nthChild = "";
            var sameTagSiblings;
            try {
                sameTagSiblings = parent.children(name);
            } catch (e) {
                path = "*" + (path ? ">" + path : "");
                node = parent;
                continue;
            }
            if (sameTagSiblings.length > 1) {
                allSiblings = parent.children();
                var index = allSiblings.index(realNode) + 1;
                if (index > 0) {
                    nthChild = ":nth-child(" + index + ")";
                }
            }
            var idClass = "";
            ignoreClass = false;
            if (name != "body" && name != "html") {
                if (jQueryTRT(realNode).prop("id").length > 0) {
                    idClass = "#" + realNode.id;
                } else if (jQueryTRT(realNode).prop("class").length > 0 && !firstNode && !ignoreClass) {
                    /* idClass = "."+realNode.className.trim().replace(/ /g, ".").replace(".is-light", "").replace(".is-dark", "").replace(".is-complete", "").replace(".is-processing", "").replace("..",".").replace("..",".").replace("..",".").replace("..",".").replace("..","."); idClass = idClass.replace(".DomOutlineBox", "").replace(".vertical-mega-menu", "").replace(".horizontal-mega-menu", ""); */ if (
                        jQueryTRT(realNode).attr("class") != undefined &&
                        jQueryTRT(realNode).attr("class").trim() != ""
                    ) {
                        idClass = "." + jQueryTRT(realNode).attr("class").trim().split(" ")[0];
                    }
                }
            }
            if (jQueryTRT.inArray(name, ["li", "ul", "header"]) !== -1) {
                name += nthChild;
            }
            if (jQueryTRT.inArray(name, ["div"]) !== -1 && idClass == "") {
                name += nthChild;
            }
            /* name += nthChild; */ firstNode = false;
            path = name + idClass + (path ? ">" + path : "");
            node = parent;
        }
        return path;
    } /* DEPRECATED function getParameterByName(name, url) { if (!url) url = window.location.href; name = name.replace(/[\[\]]/g, "\\$&"); var regex = new RegExp("[?&]" + name + "(=([^&#]*)|&|#|$)"), results = regex.exec(url); if (!results) return null; if (!results[2]) return ''; return decodeURIComponent(results[2].replace(/\+/g, " ")); } */
}
if (typeof mmBeforeLoaded == "undefined") {
    var trtMegaMenuShop = "dinluksus.myshopify.com";
    var mmBeforeLoaded = true;
    if (typeof InstantClick !== "undefined") {
        InstantClick.on("change", function (isInitialLoad) {
            if (!isInitialLoad) {
                ulPaths = [];
                storeUlCount = 0;
                storeNavCount = 0;
                if (typeof loadFlipClockTRT !== "undefined") {
                    loadFlipClockTRT(jQueryTRT);
                }
                if (typeof loadTRTMegaMenu !== "undefined") {
                    loadTRTMegaMenu();
                } else {
                    setTimeout(function () {
                        loadTRTMegaMenu();
                    }, 1000);
                }
            }
        });
    }
    var hideOriginalMenuInterval;
    function hideOriginalMenu() {
        hideOriginalMenuInterval = setInterval(function () {
            menu = "menu";
            var links = [];
            jQueryTRT.each(linkLists, function (key, item) {
                if (menu == key) {
                    links = item.items;
                    return false;
                }
            });
            if (menu != "none" && links.length > 0) {
                jQueryTRT("ul,nav").each(function () {
                    var elementFits = 0;
                    jQueryTRT(this)
                        .find(">li")
                        .each(function () {
                            var href = jQueryTRT(this).find("a").first().attr("href");
                            /*if (typeof href !== "undefined") { href = href.replace("http://"+trtMegaMenuShop,"").replace("https://"+trtMegaMenuShop,""); }*/ if (links[elementFits] != undefined && href == links[elementFits]) {
                                elementFits++;
                            } else if (elementFits > 0 && elementFits != links.length) {
                                elementFits = 0;
                                if (href == links[0]) {
                                    elementFits = 1;
                                }
                            }
                        });
                    if (elementFits > 0 && elementFits == links.length) {
                        jQueryTRT(this).addClass("trt-disabled-menu");
                    }
                });
            }
        }, 50);
        setTimeout(function () {
            jQueryTRT(".trt-disabled-menu").removeClass("trt-disabled-menu");
            clearInterval(hideOriginalMenuInterval);
        }, 3000);
    }
    function loadJqueryTRT() {
        var xhr = new XMLHttpRequest();
        xhr.onreadystatechange = function () {
            if (xhr.readyState == XMLHttpRequest.DONE) {
                var data = xhr.responseText;
                jQueryTRT = data.replace(/jQuery/g, "jQueryTRT");
                eval(jQueryTRT);
                if (typeof jQuery !== "undefined") {
                    $ = jQuery.noConflict();
                }
                if (typeof hideOriginalMenu != "undefined") {
                    hideOriginalMenu();
                }
                if (typeof loadFlipClockTRT !== "undefined") {
                    loadFlipClockTRT(jQueryTRT);
                }
                if (typeof loadTRTMegaMenu !== "undefined") {
                    loadTRTMegaMenu();
                } else {
                    setTimeout(function () {
                        loadTRTMegaMenu();
                    }, 1000);
                }
            }
        };
        xhr.open("GET", "https://ajax.googleapis.com/ajax/libs/jquery/1.11.1/jquery.min.js", true);
        xhr.send(null);
    }
    var jQueryTRT;
    function TRTMegaMenuMain() {
        if (typeof jQuery == "undefined") {
            loadJqueryTRT();
        } else {
            var vernums = jQuery.fn.jquery.split(".");
            if ((parseInt(vernums[0]) == 1 && parseInt(vernums[1]) >= 7) || parseInt(vernums[0]) > 1) {
                jQueryTRT = jQuery;
                if (typeof hideOriginalMenu != "undefined") {
                    hideOriginalMenu();
                }
                if (typeof loadFlipClockTRT !== "undefined") {
                    loadFlipClockTRT(jQueryTRT);
                }
                if (typeof loadTRTMegaMenu !== "undefined") {
                    loadTRTMegaMenu();
                } else {
                    setTimeout(function () {
                        loadTRTMegaMenu();
                    }, 1000);
                }
            } else {
                loadJqueryTRT();
            }
        }
    }
    if (window.self !== window.top || false) {
        /* in preview or if customMenuUls is defined, start loading immediately */ TRTMegaMenuMain();
    } else {
        /* on frontend load after dom content loaded event to emulate deferred exec */ if (document.readyState !== "loading") {
            TRTMegaMenuMain();
        } else {
            document.addEventListener("DOMContentLoaded", TRTMegaMenuMain);
        }
    }
}
